import { AccessGuids, AlertClassColour, ApplicationNames, ConfigSystemParams, msSize, StorageValues } from 'src/app/core/consts';
import { AfterViewChecked, AfterViewInit, Component, EventEmitter, HostListener, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AssistantSearchKind, ChatGptAction, ChatGptConfidence, ChatGptIntentChip, ChatGptIntentStage, ChatGptModalTarget } from 'src/app/core/types/chatgpt/types-chatgpt';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, filter, forkJoin, map, Observable, of, Subscription, throwError } from 'rxjs';
import { ChatGptActionCard, ChatGptActionHistoryEntry, ChatGptActionLegacy, ChatGptActionPayload, ChatGptExplainabilityStep, ChatGptForcedUserIntent, ChatGptInsightsSummary, ChatGptNavigateAction, ChatGptOpenModalAction, ChatGptResponse, ChatGptStageStep } from 'src/app/core/interfaces/chatgpt/interfaces-chatgpt';
import { ChatGptService } from 'src/app/core/services/utelize/general/chatgpt-service';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyDTO } from 'src/app/core/models/system/company/company.dto';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PageCompMenuBootstrapComponent } from 'src/app/core/page-components/page-comp-menu-bootstrap/page-comp-menu-bootstrap.component';
import { SureSimSearchService } from 'src/app/core/services/utelize/general/suresim-search-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { Ticket } from 'src/app/core/models/system/support/ticket-hub/ticket';
import { TicketDTO } from 'src/app/core/models/system/support/ticket-hub/ticket.dto';
import { TicketHubService } from 'src/app/core/services/utelize/system/support/ticket-hub/ticket-hub.service';
import { TopBarService } from 'src/app/core/services/utelize/general/top-bar-service';
import { UploadCentreModalFormSearchComponent } from '../../_file-transfers/upload-centre-modal-form-search/upload-centre-modal-form-search.component';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-chat-gpt-modal-form',
  templateUrl: './chat-gpt-modal-form.component.html',
  styleUrls: ['./chat-gpt-modal-form.component.scss']
})

export class ChatGptModalFormComponent implements AfterViewChecked, AfterViewInit, OnDestroy, OnInit {
  
  @Output() assistantActionRequested: EventEmitter<ChatGptAction>=new EventEmitter<ChatGptAction>();
  @Output() chatGptFormCancelled    : EventEmitter<void>=new EventEmitter<void>();
  @Output() chatGptFormSaved        : EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('chatGptContentForm', { static: false }) chatGptContentForm!: TemplateRef<void>;
  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('popupMenuResponse')                     popupMenuResponse! : PageCompMenuBootstrapComponent;
  @ViewChild('uploadSearchForm',   { static: false }) uploadSearchForm!  : UploadCentreModalFormSearchComponent;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;
  
  get initialStatus(): string { return this.chatGptAllowAskAnything ? "Ask anything" : "Search SureSIM"; }

  get chatGptAliasShort() { return this.configSystemService.getValue(ConfigSystemParams.ChatGptAliasShort, ApplicationNames.ChatGPT ); }
  get chatGptAliasFull () { return this.configSystemService.getValue(ConfigSystemParams.ChatGptAliasFull,  ApplicationNames.ChatGPT ); }
  get modalBackGround  () { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                            return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false     )  }

  get chatGptAllowAskAnything      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ChatGptAllowAskAnything,           false) &&
                                               this.componentAccessUserService.hasAccessGuid(AccessGuids.FormChatGptAllowAskAnything,           true ); }
  get chatGptPulseResponseArea     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ChatGptPulseResponseArea,          true ); }
  get chatGptRetainSessionHistory  () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ChatGptRetainSessionHistory,       false); }
  get chatGptShowConnectionTypeIcon() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormChatGptShowConnectionTypeIcon, true ); }
  get chatGptShowExplainability    () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ChatGptShowExplainability,         false); }
  get chatGptShowInsights          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ChatGptShowInsights,               false); }
  get chatGptShowStageStrip        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ChatGptShowStageStrip,             false); }
  get chatGptUseAzureOpenAi        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ChatGptUseAzureOpenAi,             true ); }
                          
  private assistantOpen               : boolean=false;
  private autoRunBatchQueue           : boolean=false;
  private cardsMemoKey                : string | undefined;
  private cardsMemoValue              : ChatGptActionCard[] | undefined;
  private chatGptFormModalRef!        : NgbModalRef;
  private forcedCompanyIntentName     : string | undefined;
  private forcedGlobalSearchTerm      : string | undefined;
  private forcedNavigationRoute       : string | undefined;
  private forcedRaiseTicketFor        : string | undefined;
  private forcedSimIntent             : string | undefined;
  private forcedTicketIntent          : number | undefined;
  private forcedTicketIntentQuery     : string | undefined;
  private forcedUserIntent            : ChatGptForcedUserIntent | undefined;
  private lastDynamicResponseHeight   : number | undefined;
  private lastDynamicResponseMode     : boolean | undefined;
  private latestRequestToken          : number=0;
  private latestTopBarCompanyId       : number | undefined;
  private modalDragPending            : boolean=false;
  private modalDragStartClientX       : number=0;
  private modalDragStartClientY       : number=0;
  private modalDragStartTranslateX    : number=0;
  private modalDragStartTranslateY    : number=0;
  private modalTranslateX             : number=0;
  private modalTranslateY             : number=0;
  private modalIsDragging             : boolean=false;
  private modelConversationHistory    : { assistantReply: string; userPrompt: string }[]=[];
  private pinnedActionKeys            : Set<string>=new Set<string>();
  private pinnedActionOrder           : string[]=[];
  private prompt                      : string="";
  private routerEventsSub             : Subscription | undefined;
  private tipsHidden                  : boolean=false;
  private topBarCompanySub            : Subscription | undefined;
  private userPromptRaw               : string="";

  private static readonly contextLinePrefix                        ='[SureSIM Context]';
  private static readonly promptLinePrefix                         ='[User Prompt]';
  private static readonly routeAliasMap    : Record<string, string>=SureSimSearchService.routeAliasMap;
  private static readonly routePageLabelMap: Record<string, string>=SureSimSearchService.routePageLabelMap;
  private static readonly responseJsonHint : string                =`You are SureSIM AI — an intelligent assistant embedded in SureSIM, an enterprise eSIM lifecycle management platform. Help administrators manage SIM cards, users, companies, devices, provisioning, and support tickets. Be concise and action-oriented; prefer structured actions over plain-text explanations where possible.

Return either plain text OR JSON with this shape:
{
  "reply": "your user-facing response",
  "actions": [
    {
      "type": "navigate|open_modal",
      "label": "optional short button text"
    },
    {
      "type": "navigate",
      "destination": "dashboard|availablesims|managesims|provision|portalusers|simusers|reports|suppliers|companies|timeline|ticketshub",
      "payload": {
        "companyName": "optional when destination is companies",
        "ticketId": 0,
        "iccid": "optional when destination is managesims"
      }
    },
    {
      "type": "open_modal",
      "modal": "ticket|provision|user_portal|user_sim|company|timeline|manage_sim|upload|download",
      "payload": {
        "companyId": 0,
        "companyName": "optional when companyId unknown",
        "userId": 0,
        "userName": "optional username/email/fullname for user actions",
        "deviceId": 0,
        "iccid": "",
        "deviceTypeId": -1
      }
    }
  ]
}
If company ID is unknown, include companyName. Do not wrap JSON in markdown.`;

  public activeIntentStage        : ChatGptIntentStage='idle';
  public alertColourProgress      : string=AlertClassColour.Green;
  public assistantActionHistory   : ChatGptActionHistoryEntry[]=[];
  public assistantDiagnosticsOpen : boolean=false;
  public chatGptForm!             : UntypedFormGroup;
  public confirmationReason       : string="";
  public copilotMode              : boolean=true;
  public curUser                  : SystemUserDTO;
  public explainabilityMode       : boolean=false;
  public explainabilityTrace      : ChatGptExplainabilityStep[]=[];
  public focusedActionCardIndex   : number=0;
  public formSubmitted            : boolean=false;
  public liveIntentLabel          : string="";
  public onboardingStepIndex      : number=0;
  public onboardingVisible        : boolean=false;
  public pendingActions           : ChatGptAction[]=[];
  public pendingConfirmationAction: ChatGptAction | undefined;
  public pinnedDocked             : boolean=false;
  public progressInformation      : string="";
  public queuedBatchPrompts       : string[]=[];
  public responsePulseOn          : boolean=false;
  public selectedIntentChip       : ChatGptIntentChip='all';
  public showChatBorder           : boolean=false;
  public showInsightsPanel        : boolean=false;

  public popupMenuItems_Response=[
    { label: "Response - Clear",  command: () => this.popupClearResponse() },
    { label: "Response - Save ",  command: () => this.popupSaveResponse()  }
  ];

  constructor(
    private authenticationService     : AuthenticationService,
    private chatGptService            : ChatGptService,
    private companiesService          : CompaniesService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private devicesService            : DevicesService,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private lastPassKillerService     : LastPassKillerService,
    private modalService              : NgbModal,
    private router                    : Router,
    private sureSimSearchService      : SureSimSearchService,
    private ticketHubService          : TicketHubService,
    private topBarService             : TopBarService,
    private usersService              : UsersService
  ) {
      this.curUser=this.authenticationService.currentUserObject();
  }
  
  public ngOnInit(): void {
    try {
      this.topBarCompanySub?.unsubscribe();

      this.topBarCompanySub=this.topBarService.sureSimCompanyId$.subscribe(companyId => {
        const parsed=Number(companyId ?? 0);
        this.latestTopBarCompanyId=Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
      });

      this.routerEventsSub?.unsubscribe();

      this.routerEventsSub=this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: any) => {
          const url=(event?.urlAfterRedirects ?? event?.url ?? '').toString().toLowerCase();
          if (url.includes('/account/login') || url.endsWith('/login') || url.includes('/login?')) {
            this.forceCloseModalIfOpen();
          }
        });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
      this.syncResponseHeightToFooter();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewChecked(): void {
    try {
      this.syncResponseHeightToFooter();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
      this.routerEventsSub?.unsubscribe();
      this.topBarCompanySub?.unsubscribe();
      this.forceCloseModalIfOpen();
      this.clearDockedLayoutState();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public resetMainVariables(): void {
    try {
      this.loadPinnedActionKeys();
      this.loadAssistantPreferences();
      this.loadOnboardingState();
      this.loadAssistantTimeline();
      this.activeIntentStage        ='idle';
      this.alertColourProgress      =AlertClassColour.Green;
      this.confirmationReason       ="";
      this.explainabilityTrace      =[];
      this.focusedActionCardIndex   =0;
      this.forcedCompanyIntentName  =undefined;
      this.forcedGlobalSearchTerm   =undefined;
      this.forcedNavigationRoute    =undefined;
      this.forcedRaiseTicketFor     =undefined;
      this.forcedSimIntent          =undefined;
      this.forcedTicketIntent       =undefined;
      this.forcedTicketIntentQuery  =undefined;
      this.forcedUserIntent         =undefined;
      this.formSubmitted            =false;
      this.liveIntentLabel          ="";
      this.pendingActions           =[];
      this.pendingConfirmationAction=undefined;
      this.progressInformation      =this.initialStatus;
      this.prompt                   ="";
      this.queuedBatchPrompts       =[];
      this.responsePulseOn          =this.chatGptPulseResponseArea;
      this.selectedIntentChip       =this.selectedIntentChip ?? 'all';
      this.showChatBorder           =false;
      this.userPromptRaw            ="";

      this.populateFormFields(this.chatGptForm, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      this.openModal();
      
      this.assistantOpen=true;
      this.saveAssistantPreferences();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public restoreIfPreviouslyOpenAndDocked(): void {
    try {
      if (this.wasOpenAndDocked())
        this.openForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.modalDragPending=false;
      this.modalIsDragging =false;
      this.modalTranslateX =0;
      this.modalTranslateY =0;
      
      this.applyDockedLayoutState();
      this.chatGptFormModalRef=this.modalService.open(this.chatGptContentForm, { animation  : !this.pinnedDocked,
                                                                                 backdrop   : this.pinnedDocked ? false : this.modalBackGround,
                                                                                 centered   : !this.pinnedDocked,
                                                                                 keyboard   : false,
                                                                                 size       : msSize.Large,
                                                                                 windowClass: this.modalWindowClass });
      this.applyDockedLayoutState();
    }
    catch(e) {
      this.chatGptFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private get modalWindowClass(): string {
    try {
      return this.pinnedDocked ? 'assistant-chat-modal-window assistant-chat-modal-window-docked' : 'assistant-chat-modal-window';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'assistant-chat-modal-window';
    }
  }

  public togglePinnedDocked() {
    try {
      this.pinnedDocked=!this.pinnedDocked;
      this.applyPinnedDockedState();
      this.saveAssistantPreferences();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyPinnedDockedState() {
    try {
      if (!this.chatGptFormModalRef)
        return;
        
      this.chatGptFormModalRef.close();
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyDockedLayoutState() {
    try {
      const dockClass='assistant-chat-docked-right';

      if (this.pinnedDocked) {
        document.body.classList.add(dockClass);
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('padding-right');
        document.body.style.removeProperty('overflow');

      } else {
        document.body.classList.remove(dockClass);
      }
    }
    catch(e) {
      //CRN_20260223 - Ignore DOM sync failures
      // this.exceptionsService.handleException(<Error>e);
    }
  }

  private clearDockedLayoutState() {
    try {
      document.body.classList.remove('assistant-chat-docked-right');
    }
    catch {
      //CRN_20260223 - Ignore DOM sync failures
      // this.exceptionsService.handleException(<Error>e);
    }
  }

  public onAssistantHeaderMouseDown(event: MouseEvent): void {
    try {
      if (this.pinnedDocked || event.button !== 0)
        return;

      const target=event.target as HTMLElement | null;

      if (target?.closest('button, a, input, textarea, select, label, .btn-close'))
        return;

      const dialog=this.getAssistantModalDialogElement();

      if (!dialog)
        return;

      this.modalDragStartClientX   =event.clientX;
      this.modalDragStartClientY   =event.clientY;
      this.modalDragStartTranslateX=this.modalTranslateX;
      this.modalDragStartTranslateY=this.modalTranslateY;
      this.modalDragPending        =true;
      this.modalIsDragging         =false;

      event.preventDefault();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  @HostListener('document:mousemove', ['$event'])
  public onDocumentMouseMove(event: MouseEvent): void {
    try {
      if (!this.modalIsDragging || this.pinnedDocked) {
        if (!this.modalDragPending || this.pinnedDocked)
          return;
      }

      const dialog=this.getAssistantModalDialogElement();

      if (!dialog) {
        this.modalIsDragging =false;
        this.modalDragPending=false;

        return;
      }

      if (!this.modalIsDragging && this.modalDragPending) {
        const deltaX=Math.abs(event.clientX-this.modalDragStartClientX);
        const deltaY=Math.abs(event.clientY-this.modalDragStartClientY);

        if (deltaX + deltaY < 4)
          return;

        dialog.style.willChange='transform';
        this.modalIsDragging   =true;
        this.modalDragPending  =false;
      }

      if (!this.modalIsDragging)
        return;

      const deltaX          =event.clientX - this.modalDragStartClientX;
      const deltaY          =event.clientY - this.modalDragStartClientY;
      this.modalTranslateX  =this.modalDragStartTranslateX + deltaX;
      this.modalTranslateY  =this.modalDragStartTranslateY + deltaY;
      dialog.style.transform=`translate3d(${this.modalTranslateX}px, ${this.modalTranslateY}px, 0)`;
    }
    catch {
      this.modalIsDragging=false;
      this.modalDragPending=false;
    }
  }

  @HostListener('document:mouseup')
  public onDocumentMouseUp(): void {
    try {
      this.modalIsDragging =false;
      this.modalDragPending=false;
      const dialog         =this.getAssistantModalDialogElement();

      if (dialog)
        dialog.style.removeProperty('will-change');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getAssistantModalDialogElement(): HTMLElement | null {
    try {
      const selector='.assistant-chat-modal-window:not(.assistant-chat-modal-window-docked) .modal-dialog';
      
      return document.querySelector(selector) as HTMLElement | null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  private closeModalWindow() {
    try {
      this.modalIsDragging =false;
      this.modalDragPending=false;
      this.modalTranslateX =0;
      this.modalTranslateY =0;

      this.clearDockedLayoutState();
      this.chatGptFormModalRef.close();
      this.assistantOpen=false;
      this.saveAssistantPreferences();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private forceCloseModalIfOpen(): void {
    try {
      this.modalIsDragging =false;
      this.modalDragPending=false;
      this.modalTranslateX =0;
      this.modalTranslateY =0;

      this.clearDockedLayoutState();
      this.chatGptFormModalRef?.close();
      this.chatGptFormModalRef?.dismiss?.();
    }
    catch(e) {
      //CRN_20260223 - Ignore
      // this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region chatGptForm
  
  get formOfChatGpt() {
    return this.chatGptForm.controls;
  }
    
  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private buildForm() {
    try {
      this.removeFormFields(this.chatGptForm);
       this.chatGptForm=this.formBuilder.group({ });
      
      this.addFormFields(this.chatGptForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.chatGptForm) {
        this.addFormControl(this.chatGptForm, "prompt",     "",                   [Validators.required], false);
        this.addFormControl(this.chatGptForm, "pulseCheck", this.responsePulseOn, [                   ], false);
        this.addFormControl(this.chatGptForm, "response",   "",                   [                   ], false);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | string,
                         validators: Validators,
                         disabled  : boolean) {
    try {
      form.addControl(dataField, new FormControl(
        {
          value   : value,
          disabled: disabled
        },
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  private populateFormFields(formGroup: UntypedFormGroup, clearFields: boolean) {
    try {
      if (formGroup==this.chatGptForm && this.chatGptForm && this.chatGptForm.controls) {
        this.chatGptForm.controls["prompt"].setValue(clearFields ? "" : "");
        this.chatGptForm.controls["response"].setValue(clearFields ? "" : "");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onPromptInput(value: string): void {
    try {
      const text=this.normaliseSearchVerb((value ?? '').trim());

      if (!text) {
        this.liveIntentLabel='';
        return;
      }

      const globalFindTerm=this.extractGlobalFindTerm(text);
      const userIntent    =this.forcedUserIntentFromGenericFind(globalFindTerm) ?? this.extractUserIntentFromPrompt(text);
      const companyIntent =userIntent || globalFindTerm ? undefined : this.extractCompanyNameFromCompanyIntentPrompt(text);
      const simIntent     =this.extractSimIntentFromPrompt(text);
      const ticketQuery   =this.extractTicketIntentFromPrompt(text);
      const ticketId      =this.chatGptService.parsePositiveInteger(ticketQuery);
      const raiseTicket   =this.extractRaiseTicketTargetFromPrompt(text);
      const navigateRoute =companyIntent || globalFindTerm || raiseTicket || simIntent || ticketQuery || userIntent
                          ? undefined
                          : this.extractNavigationIntentFromPrompt(text);

      if (userIntent)
        this.liveIntentLabel=`User search`;

      else if (companyIntent)
        this.liveIntentLabel=`Company lookup`;

      else if (simIntent)
        this.liveIntentLabel=`SIM lookup`;

      else if (ticketId)
        this.liveIntentLabel=`Ticket #${ticketId}`;

      else if (ticketQuery)
        this.liveIntentLabel=`Ticket search`;

      else if (raiseTicket)
        this.liveIntentLabel=`Raise ticket`;

      else if (globalFindTerm) {
        const termNorm=this.chatGptService.normalizeMatchText(globalFindTerm);
        if (/^(portal\s+user|sim\s+user|esim\s+user|user)\b/.test(termNorm))
          this.liveIntentLabel=`User search`;
        
        else if (/^company\b/.test(termNorm))
          this.liveIntentLabel=`Company lookup`;
        
        else if (/^(sim|esim|iccid|device)\b/.test(termNorm))
          this.liveIntentLabel=`SIM lookup`;
        
        else if (/^ticket\b/.test(termNorm))
          this.liveIntentLabel=`Ticket search`;
        
        else
          this.liveIntentLabel=`Global search`;

        } else if (navigateRoute)
          this.liveIntentLabel=`Navigate`;

        else
          this.liveIntentLabel=`AI model`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onPromptEnter(event: KeyboardEvent) {
    try {
      if (event.key==="Enter" && !event.shiftKey) {
        event.preventDefault();
        this.chatGptFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public chatGptFormSubmit() {
    try {
      this.formSubmitted=true;
      
      if (this.chatGptForm.valid) {
        this.formSubmitted=false;
        const promptInput =this.chatGptForm.get("prompt")?.value  || "";
        const batchPrompts=this.splitBatchPrompts(promptInput);
        const firstPrompt =(batchPrompts[0] ?? '').trim();

        if (!firstPrompt)
          return;

        this.queuedBatchPrompts=batchPrompts.slice(1);
        this.chatGptForm.get("prompt")?.setValue("");
        this.chatGptForm.get("response")?.setValue("");

        this.selectedIntentChip       ='all';
        this.focusedActionCardIndex   =0;
        this.pendingActions           =[];
        this.pendingConfirmationAction=undefined;
        this.confirmationReason       ="";

        this.handlePromptIntent(firstPrompt, promptInput);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public runNextBatchPrompt() {
    try {
      this.autoRunBatchQueue=false;
      this.runNextBatchPromptInternal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public runAllBatchPrompts() {
    try {
      this.autoRunBatchQueue=true;
      this.runNextBatchPromptInternal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private runNextBatchPromptInternal() {
    try {
      const next=this.queuedBatchPrompts.shift();
  
      if (!next) {
        this.autoRunBatchQueue=false;
        return;
      }

      this.handlePromptIntent(next, next);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private continueBatchQueueIfNeeded() {
    try {
      if (!this.autoRunBatchQueue || this.queuedBatchPrompts.length===0) {
        if (this.queuedBatchPrompts.length===0) {
          this.autoRunBatchQueue=false;
        }
        return;
      }

      setTimeout(() => this.runNextBatchPromptInternal(), 0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handlePromptIntent(promptText: string, rawPrompt: string) {
    try {
      const resolvedPrompt    =this.normaliseSearchVerb(this.resolveFollowUpPrompt(promptText));
      this.userPromptRaw      =promptText;
      this.explainabilityTrace=[];

      this.traceExplainability('prompt.raw', promptText);

      if (resolvedPrompt !== promptText)
        this.traceExplainability('prompt.resolved', resolvedPrompt);
  
      this.forcedGlobalSearchTerm =this.extractGlobalFindTerm(resolvedPrompt);
      this.forcedUserIntent       =this.forcedUserIntentFromGenericFind(this.forcedGlobalSearchTerm) ?? this.extractUserIntentFromPrompt(resolvedPrompt);
      this.forcedCompanyIntentName=this.forcedUserIntent || this.forcedGlobalSearchTerm
                                   ? undefined
                                   : this.extractCompanyNameFromCompanyIntentPrompt(resolvedPrompt);
      this.forcedSimIntent        =this.extractSimIntentFromPrompt(resolvedPrompt);
      this.forcedTicketIntentQuery=this.extractTicketIntentFromPrompt(resolvedPrompt);
      this.forcedTicketIntent     =this.chatGptService.parsePositiveInteger(this.forcedTicketIntentQuery);
      this.forcedRaiseTicketFor   =this.extractRaiseTicketTargetFromPrompt(resolvedPrompt);
      this.forcedNavigationRoute  =this.extractNavigationIntentFromPrompt(resolvedPrompt);
      this.prompt                 =this.buildContextualPrompt(resolvedPrompt);
  
      if (this.forcedUserIntent) {
        this.setIntentStage('user');
        this.traceExplainability('intent', `user:${this.forcedUserIntent.userType}:${this.forcedUserIntent.userName}`);
        this.recordPromptHistory('user', resolvedPrompt);
        this.handleForcedUserIntent(this.forcedUserIntent);
        return;
      }

      if (this.forcedCompanyIntentName) {
        this.setIntentStage('company');
        this.traceExplainability('intent', `company:${this.forcedCompanyIntentName}`);
        this.recordPromptHistory('company', resolvedPrompt);
        this.handleForcedCompanyIntent(this.forcedCompanyIntentName);
        return;
      }

      if (this.forcedSimIntent) {
        this.setIntentStage('sim');
        this.traceExplainability('intent', `sim:${this.forcedSimIntent}`);
        this.recordPromptHistory('sim', resolvedPrompt);
        this.handleForcedSimIntent(this.forcedSimIntent);
        return;
      }

      if (this.forcedTicketIntent) {
        this.setIntentStage('ticket');
        this.traceExplainability('intent', `ticket-id:${this.forcedTicketIntent}`);
        this.recordPromptHistory('ticket', resolvedPrompt);
        this.handleForcedTicketIntent(this.forcedTicketIntent);
        return;
      }

      if (this.forcedTicketIntentQuery) {
        this.setIntentStage('ticket');
        this.traceExplainability('intent', `ticket:${this.forcedTicketIntentQuery}`);
        this.recordPromptHistory('ticket', resolvedPrompt);
        this.handleForcedTicketSearchIntent(this.forcedTicketIntentQuery);
        return;
      }

      if (this.forcedRaiseTicketFor) {
        this.setIntentStage('raise_ticket');
        this.traceExplainability('intent', `raise-ticket:${this.forcedRaiseTicketFor}`);
        this.recordPromptHistory('raise_ticket', resolvedPrompt);
        this.handleForcedRaiseTicketIntent(this.forcedRaiseTicketFor);
        return;
      }

      if (this.forcedGlobalSearchTerm) {
        this.setIntentStage('search');
        this.traceExplainability('intent', `global-search:${this.forcedGlobalSearchTerm}`);
        this.recordPromptHistory('search', resolvedPrompt);
        this.handleForcedGlobalSearch(this.forcedGlobalSearchTerm);
        return;
      }

      if (this.forcedNavigationRoute) {
        this.setIntentStage('navigate');
        this.traceExplainability('intent', `navigate:${this.forcedNavigationRoute}`);
        this.recordPromptHistory('navigate', resolvedPrompt);
        this.handleForcedNavigationIntent(this.forcedNavigationRoute);
        return;
      }

      if (!this.chatGptAllowAskAnything) {
        this.setIntentStage('model');
        this.traceExplainability('intent', 'model:denied-ask-anything');
        this.denyAskAnything();
        return;
      }

      this.setIntentStage('model');
      this.traceExplainability('intent', 'model');
      this.recordPromptHistory('model', resolvedPrompt);
      this.sendPrompt();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private denyAskAnything(): void {
    try {
      this.showChatBorder     =false;
      this.alertColourProgress=AlertClassColour.Red;
      this.progressInformation=this.initialStatus;
      this.pendingActions     =[];
      this.chatGptForm.controls["response"].setValue("You are not authorised to ask open questions. Please use one of the available features.");
      this.continueBatchQueueIfNeeded();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private splitBatchPrompts(prompt: string): string[] {
    try {
      const normalized=(prompt ?? '').trim();

      if (!normalized)
        return [];

      return normalized
        .split(/\s+(?:and then|then)\s+|[;\n]+/i)
        .map(x => x.trim())
        .filter(x => x.length > 0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private resolveFollowUpPrompt(prompt: string): string {
    try {
      const raw  =(prompt ?? '').trim();
      const lower=raw.toLowerCase();

      if ((lower==='again' || lower==='repeat' || lower==='same') && this.modelConversationHistory.length>0)
        return this.modelConversationHistory[this.modelConversationHistory.length-1].userPrompt;

      return raw;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public pulseClick() {
    try {
      this.responsePulseOn=Boolean(this.chatGptForm.get("pulseCheck")?.value);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public chatGptFormCancel() {
    try {
      this.chatGptFormCancelled.emit();
      this.closeModalWindow();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  public sendPrompt() {
    try {
      const requestToken=this.createRequestToken();
      this.showChatBorder     =true;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation="Processing...";

      let dataSource: Observable<any>=this.chatGptUseAzureOpenAi ? this.chatGptService.sendMessageToAzureOpenAi(this.prompt)
                                                                 : this.chatGptService.sendMessage(this.prompt);

      dataSource
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!this.isActiveRequestToken(requestToken)) {
            return;
          }
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;
          this.handleChatResponse(data);
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken)) {
            return;
          }

          //CRN_20260223 - TopbarComponent now displays error messages
          // this.alertColourProgress=AlertClassColour.Red;
          // this.progressInformation=error.message;
          this.showChatBorder     =false;
          this.continueBatchQueueIfNeeded();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public handleChatResponse(response: string) {
    try {
      const parsedResponse=this.tryParseStructuredAiResponse(response);
      this.traceExplainability('model.rawResponse', response?.slice(0, 280) ?? '');

      const replyText=parsedResponse?.reply ? parsedResponse.reply : this.sanitizeLegacyResponse(response);

      this.chatGptForm.controls["response"].setValue(replyText);

      if (parsedResponse?.reply)
        this.traceExplainability('model.reply', replyText);

      this.pushModelConversationHistory(this.userPromptRaw, replyText);

      if (this.forcedUserIntent) {
        //CRN_20260225 - 'any'==both Portal & SIM users
        this.pendingActions=this.forcedUserIntent.userType==='any'
          ? this.uniqueActions([
              ...this.buildUserIntentActions(this.forcedUserIntent.userName, 'portal'),
              ...this.buildUserIntentActions(this.forcedUserIntent.userName, 'sim')
            ])
          : this.buildUserIntentActions(this.forcedUserIntent.userName, this.forcedUserIntent.userType);
        this.auditAssistantDecision('forced_user_actions');
        this.continueBatchQueueIfNeeded();
        return;
      }
      if (this.forcedCompanyIntentName) {
        this.pendingActions=this.buildCompanyIntentActions(this.forcedCompanyIntentName);
        this.auditAssistantDecision('forced_company_actions');
        this.continueBatchQueueIfNeeded();
        return;
      }

      if (parsedResponse?.actions?.length) {
        this.pendingActions=parsedResponse.actions;
        this.traceExplainability('model.actions', `${this.pendingActions.length}`);
        this.auditAssistantDecision('model_actions');
        this.continueBatchQueueIfNeeded();
        return;
      }

      const commandPattern=/<command>(.*?)<\/command>/i;
      const match         =response.match(commandPattern);

      if (match && match[1]) {
        const command=match[1].toLowerCase();

        if (command.startsWith('open:')) {
          const destination=command.split(':')[1];
          this.navigateBasedOnCommand(destination, undefined, !this.copilotMode);
        }
      }
      this.continueBatchQueueIfNeeded();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private navigateBasedOnCommand(destination: string, payload?: ChatGptActionPayload, closeModal: boolean=true) {
    try {
      if (this.sureSimSearchService.navigate(destination, payload)) {
        if (closeModal)
          this.closeModalWindow();

      } else {
        this.alertColourProgress=AlertClassColour.Red;
        this.progressInformation=`Unknown navigation target '${destination}'`;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handleForcedNavigationIntent(routeAliasKey: string) {
    try {
      const key      =(routeAliasKey ?? '').trim().toLowerCase();
      const routePath=ChatGptModalFormComponent.routeAliasMap[key];

      if (!routePath) {
        this.alertColourProgress=AlertClassColour.Red;
        this.progressInformation=`Unknown navigation target '${routeAliasKey}'`;
        this.continueBatchQueueIfNeeded();
        return;
      }

      const pageLabel=ChatGptModalFormComponent.routePageLabelMap[routePath] ?? routePath;

      this.pendingActions     =[];
      this.showChatBorder     =false;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation=this.initialStatus;
      this.chatGptForm.controls["response"].setValue(`Opening ${pageLabel}.`);

      this.auditAssistantDecision('forced_navigation');
      this.navigateBasedOnCommand(key, undefined, !this.copilotMode);
      this.continueBatchQueueIfNeeded();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onModalKeyDown(event: KeyboardEvent) {
    try {
      const target    =event.target as HTMLElement | null;
      const isTextArea=target?.tagName?.toLowerCase() === 'textarea';

      if (isTextArea && event.key !== 'Escape')
        return;

      const cards=this.filteredActionCards;

      if (!cards.length)
        return;

      if (event.key==='ArrowRight' || event.key==='ArrowDown') {
        event.preventDefault();
        this.focusedActionCardIndex=(this.focusedActionCardIndex + 1) % cards.length;
        return;
      }

      if (event.key==='ArrowLeft' || event.key==='ArrowUp') {
        event.preventDefault();
        this.focusedActionCardIndex=(this.focusedActionCardIndex - 1 + cards.length) % cards.length;
        return;
      }

      if (event.key==='Enter') {
        event.preventDefault();
        this.executePreferredFocusedAction();
        return;
      }

      if (event.key==='Escape') {
        event.preventDefault();
        this.clearPendingActions();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handleForcedCompanyIntent(companyName: string) {
    try {
      const normalizedCompanyName=(companyName ?? '').trim();

      if (!normalizedCompanyName)
        return;

      const requestToken=this.createRequestToken();

      this.showChatBorder     =true;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation="Checking company...";

      this.companiesService.getForLoggedInUser(this.curUser.userId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          const matches           =this.chatGptService.findMatchingCompanies(data, normalizedCompanyName);
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;

          if (matches.length===1) {
            this.chatGptForm.controls["response"].setValue(`I found the company '${normalizedCompanyName}' for you.`);
            this.pendingActions=this.buildCompanyIntentActions(matches[0].companyName, Number(matches[0].id));

          } else if (matches.length > 1) {
            this.chatGptForm.controls["response"].setValue(`I found multiple companies for '${normalizedCompanyName}'. Please choose one.`);
            this.pendingActions=this.buildCompanyDisambiguationActions(matches);

          } else {
            const suggestions=this.chatGptService.findSuggestedCompanies(data, normalizedCompanyName);

            if (suggestions.length>0) {
              this.chatGptForm.controls["response"].setValue(`No exact match for '${normalizedCompanyName}' — did you mean one of these?`);
              this.pendingActions=this.buildCompanyDisambiguationActions(suggestions);
            } else {
              this.pendingActions=[];
              this.chatGptForm.controls["response"].setValue(`The company '${normalizedCompanyName}' cannot be found within SureSIM.`);
            }
          }

          this.auditAssistantDecision('forced_company_resolution');
          this.continueBatchQueueIfNeeded();
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          this.pendingActions=[];
          this.showChatBorder=false;

          //CRN_20260223 - TopbarComponent now displays error messages
          // this.alertColourProgress=AlertClassColour.Red;
          // this.progressInformation=error.message;
          this.continueBatchQueueIfNeeded();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handleForcedUserIntent(userIntent: ChatGptForcedUserIntent) {
    try {
      const normalizedUserName=(userIntent.userName ?? '').trim();

      if (!normalizedUserName)
        return;
        
      const requestToken      =this.createRequestToken();
      this.showChatBorder     =true;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation="Checking user...";

      const includePortal=userIntent.userType !== 'sim';
      const includeSim   =userIntent.userType !== 'portal';
      let   truncated    =false;

      this.chatGptService.search(normalizedUserName, this.userSearchKinds(includePortal, includeSim))
      .pipe(
        map(result => {
          truncated=this.chatGptService.isSearchTruncated(result);
          return this.uniqueUsersById([...result.portalUsers, ...result.simUsers]);
        }),
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          const matchedUsers      =this.chatGptService.findMatchingUsers(data, normalizedUserName);
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;

          if (matchedUsers.length===1) {
            this.chatGptForm.controls["response"].setValue(`I found the user '${normalizedUserName}' for you.`);

            //CRN_20260225 - 'any'==both Portal & SIM users
            this.pendingActions=userIntent.userType==='any'
              ? this.buildUserActionsForMatchedUser(matchedUsers[0])
              : this.buildUserIntentActions(normalizedUserName, userIntent.userType, matchedUsers[0]);

          } else if (matchedUsers.length > 1) {
            this.chatGptForm.controls["response"].setValue(`I found multiple users for '${normalizedUserName}'. Please choose one.`);
            
            //CRN_20260225 - 'any'==both Portal & SIM users
            this.pendingActions=userIntent.userType==='any'
              ? this.uniqueActions(matchedUsers.slice(0, 5).flatMap(u => this.buildUserActionsForMatchedUser(u)))
              : this.buildUserDisambiguationActions(matchedUsers, userIntent.userType);

          } else {
            const suggestions=this.chatGptService.findSuggestedUsers(data, normalizedUserName);

            if (suggestions.length>0) {
              this.chatGptForm.controls["response"].setValue(`No exact match for '${normalizedUserName}' — did you mean one of these?`);
              this.pendingActions=userIntent.userType==='any'
                                  ? this.uniqueActions(suggestions.flatMap(u => this.buildUserActionsForMatchedUser(u)))
                                  : this.buildUserDisambiguationActions(suggestions, userIntent.userType);
            } else {
              this.pendingActions=[];
              this.chatGptForm.controls["response"].setValue(`The user '${normalizedUserName}' cannot be found within SureSIM.`);
            }
          }

          this.appendRefineSearchNote(truncated);
          this.auditAssistantDecision('forced_user_resolution');
          this.continueBatchQueueIfNeeded();
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          this.pendingActions=[];
          this.showChatBorder=false;

          //CRN_20260223 - TopbarComponent now displays error messages
          // this.alertColourProgress=AlertClassColour.Red;
          // this.progressInformation=error.message;
          this.continueBatchQueueIfNeeded();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handleForcedSimIntent(simIdentifier: string) {
    try {
      const iccid=(simIdentifier ?? '').trim();

      if (!iccid)
        return;
      
      const requestToken      =this.createRequestToken();
      this.showChatBorder     =true;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation="Checking SIM...";

      this.devicesService.getByImeiIccid(iccid)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!this.isActiveRequestToken(requestToken)) {
            return;
          }
          const resolvedIccid     =(data?.imeiIccid ?? iccid).toString();
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;

          this.chatGptForm.controls["response"].setValue(`I found SIM '${resolvedIccid}' for you.`);
          this.pendingActions=this.buildSimIntentActions(resolvedIccid, data?.status);
          this.auditAssistantDecision('forced_sim_resolution');
          this.continueBatchQueueIfNeeded();
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          this.resolveForcedSimCandidates(iccid);
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handleForcedTicketIntent(ticketId: number) {
    try {
      if (!Number.isFinite(ticketId) || !Number.isSafeInteger(ticketId) || ticketId <= 0)
        return;

      const requestToken      =this.createRequestToken();
      this.showChatBorder     =true;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation="Checking ticket...";

      this.ticketHubService.getById(ticketId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          const ticket            =this.asTicketDto(data);
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;

          this.chatGptForm.controls["response"].setValue(`I found ticket #${ticketId} for you.`);
          this.pendingActions=this.buildTicketIntentActions(ticketId, ticket);
          this.auditAssistantDecision('forced_ticket_resolution');
          this.continueBatchQueueIfNeeded();
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken)) {
            return;
          }
          this.pendingActions     =[];
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;

          this.chatGptForm.controls["response"].setValue(`The ticket '${ticketId}' cannot be found within SureSIM.`);
          this.auditAssistantDecision('forced_ticket_resolution');
          this.continueBatchQueueIfNeeded();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handleForcedTicketSearchIntent(queryText: string) {
    try {
      const query=(queryText ?? '').trim();

      if (!query)
        return;
      
      const requestToken      =this.createRequestToken();
      this.showChatBorder     =true;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation="Checking tickets...";

      const companyId=Number((this.curUser as any)?.companyId ?? (this.curUser as any)?.companyID ?? -1);
      const userId=Number(this.curUser?.userId ?? -1);

      forkJoin({
        openTickets: this.ticketHubService.getUserAndCompanyTickets(companyId, userId, -1, true, false),
        closedTickets: this.ticketHubService.getUserAndCompanyTickets(companyId, userId, -1, false, false),
      })
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: ({ openTickets, closedTickets }) => {
          if (!this.isActiveRequestToken(requestToken)) {
            return;
          }
          const allTickets        =this.chatGptService.uniqueTicketsById([...(openTickets ?? []), ...(closedTickets ?? [])]);
          const matches           =this.chatGptService.findMatchingTickets(allTickets, query);
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;

          if (matches.length===1) {
            const match=matches[0];
            this.chatGptForm.controls["response"].setValue(`I found ticket #${match.id} for you.`);
            this.pendingActions=this.buildTicketIntentActions(match.id, this.ticketDtoFromTicket(match), this.ticketMatchLabel(match), match.status, match);

          } else if (matches.length > 1) {
            this.chatGptForm.controls["response"].setValue(`I found multiple tickets for '${query}'. Please choose one.`);
            this.pendingActions=this.buildTicketDisambiguationActions(matches);

          } else {
            const suggestions=this.chatGptService.findSuggestedTickets(allTickets, query);

            if (suggestions.length>0) {
              this.chatGptForm.controls["response"].setValue(`No exact match for '${query}' — did you mean one of these?`);
              this.pendingActions=this.buildTicketDisambiguationActions(suggestions);
            } else {
              this.pendingActions=[];
              this.chatGptForm.controls["response"].setValue(`The ticket '${query}' cannot be found within SureSIM.`);
            }
          }

          this.auditAssistantDecision('forced_ticket_search_resolution');
          this.continueBatchQueueIfNeeded();
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken))
            return;
            
          this.pendingActions=[];
          this.showChatBorder=false;

          //CRN_20260223 - TopbarComponent now displays error messages
          // this.alertColourProgress=AlertClassColour.Red;
          // this.progressInformation=error.message;
          this.continueBatchQueueIfNeeded();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private resolveForcedSimCandidates(simIdentifier: string) {
    try {
      const query=(simIdentifier ?? '').trim();

      if (!query)
        return;
        
      const requestToken=this.createRequestToken();
      let   truncated   =false;

      this.chatGptService.search(query, ['Sims'])
      .pipe(
        map(result => {
          truncated=this.chatGptService.isSearchTruncated(result);
          return result.sims;
        }),
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          if (!this.isActiveRequestToken(requestToken))
            return;
            
          const matches           =this.chatGptService.findMatchingSimCandidates(data ?? [], query);
          this.pendingActions     =[];
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;

          if (matches.length===1) {
            const resolvedIccid=(matches[0].description ?? query).toString();
            this.chatGptForm.controls["response"].setValue(`I found SIM '${resolvedIccid}' for you.`);
            this.pendingActions=this.buildSimIntentActions(resolvedIccid);

          } else if (matches.length > 1) {
            this.chatGptForm.controls["response"].setValue(`I found multiple SIMs for '${query}'. Please choose one.`);
            this.pendingActions=this.buildSimDisambiguationActions(matches);

          } else {
            this.chatGptForm.controls["response"].setValue(`The SIM '${query}' cannot be found within SureSIM.`);
          }

          this.appendRefineSearchNote(truncated);
          this.auditAssistantDecision('forced_sim_resolution');
          this.continueBatchQueueIfNeeded();
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken))
            return;
            
          this.pendingActions=[];
          this.showChatBorder=false;

          //CRN_20260223 - TopbarComponent now displays error messages
          // this.alertColourProgress=AlertClassColour.Red;
          // this.progressInformation=error.message;
          this.continueBatchQueueIfNeeded();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handleForcedRaiseTicketIntent(target: string) {
    try {
      const cleanedTarget=(target ?? '').trim();

      if (!cleanedTarget)
        return;
        
      const requestToken      =this.createRequestToken();
      this.showChatBorder     =true;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation="Preparing ticket...";
      const normalized        =this.chatGptService.normalizeMatchText(cleanedTarget);
      const explicitUser      =normalized.startsWith('user ');
      const explicitCompany   =normalized.startsWith('company ');
      const explicitSim       =/^(sim|esim|device|iccid)\s/.test(normalized);
      const valueForSearch    =this.cleanPromptEntity(cleanedTarget.replace(/^(user|company|sim|esim|device|iccid)\s+/i, '')) ?? cleanedTarget;
      const userCompanyId     =this.getUserSearchCompanyId();

      forkJoin({
        companies  : explicitUser    || explicitSim  ? of([] as CompanyDTO[])          : this.companiesService.getForLoggedInUser(this.curUser.userId),
        usersPortal: explicitCompany || explicitSim  ? of([] as UserDTO[])             : this.usersService.getUsersPortal(userCompanyId),
        usersESim  : explicitCompany || explicitSim  ? of([] as UserDTO[])             : this.usersService.getUsersESim(userCompanyId),
        sims       : explicitCompany || explicitUser ? of([] as IdAndDescriptionDTO[]) : this.devicesService.getIdAndDescriptionForLoggedInUser(this.curUser.userId)
      })
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: ({ companies, usersPortal, usersESim, sims }) => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          const users         =this.uniqueUsersById([...(usersPortal ?? []), ...(usersESim ?? [])]);
          const companyMatches=this.chatGptService.findMatchingCompanies(companies ?? [], valueForSearch);
          const userMatches   =this.chatGptService.findMatchingUsers(users ?? [], valueForSearch);
          const simMatches    =this.chatGptService.findMatchingSimCandidates(sims ?? [], valueForSearch);

          const actions: ChatGptAction[]=[];

          let responseMessage=`I prepared ticket actions for '${cleanedTarget}'.`;

          if (simMatches.length===1 && (explicitSim || (!explicitUser && !explicitCompany && userMatches.length===0 && companyMatches.length===0))) {
            const simIccid=(simMatches[0].description ?? valueForSearch).toString();
            actions.push({
              type   : 'open_modal',
              modal  : 'ticket',
              payload: { iccid: simIccid },
              label  : `Open ticket form: SIM ${simIccid}`
            });
            actions.push(...this.buildSimIntentActions(simIccid));
            responseMessage=`I prepared a ticket for SIM '${simIccid}'.`;

          } else if (userMatches.length===1 && (explicitUser || (!explicitCompany && !explicitSim && companyMatches.length===0))) {
            const user   =userMatches[0];
            const display=user.fullname || user.username || user.email || valueForSearch;
            actions.push({
              type   : 'open_modal',
              modal  : 'ticket',
              payload: { userId: user.id, userName: display, companyId: user.companyID },
              label  : `Open ticket form: ${display}`
            });
            actions.push(...this.buildUserActionsForMatchedUser(user));
            responseMessage=`I prepared a ticket for user '${display}'.`;

          } else if (companyMatches.length===1 && (explicitCompany || (!explicitUser && !explicitSim && userMatches.length===0))) {
            const company=companyMatches[0];
            actions.push({
              type   : 'open_modal',
              modal  : 'ticket',
              payload: { companyId: Number(company.id), companyName: company.companyName },
              label  : `Open ticket form: ${company.companyName}`
            });
            actions.push(...this.buildCompanyIntentActions(company.companyName, Number(company.id)));
            responseMessage=`I prepared a ticket for company '${company.companyName}'.`;

          } else {
            const disambiguationActions: ChatGptAction[]=[];

            if (companyMatches.length > 0) {
              companyMatches.slice(0, 3).forEach(c => {
                disambiguationActions.push({
                  type   : 'open_modal',
                  modal  : 'ticket',
                  payload: { companyId: Number(c.id), companyName: c.companyName },
                  label  : `Raise ticket for company: ${c.companyName}`
                });
              });
            }

            if (userMatches.length > 0) {
              userMatches.slice(0, 3).forEach(u => {
                const display=u.fullname || u.username || u.email || '';
                disambiguationActions.push({
                  type   : 'open_modal',
                  modal  : 'ticket',
                  payload: { userId: u.id, userName: display, companyId: u.companyID },
                  label  : `Raise ticket for user: ${display}`
                });
              });
            }
            if (simMatches.length > 0) {
              simMatches.slice(0, 3).forEach(s => {
                const simIccid=(s.description ?? '').toString();
                disambiguationActions.push({
                  type   : 'open_modal',
                  modal  : 'ticket',
                  payload: { iccid: simIccid },
                  label  : `Raise ticket for SIM: ${simIccid}`
                });
              });
            }

            if (disambiguationActions.length > 0) {
              actions.push(...disambiguationActions);
              responseMessage=`I found multiple matches for '${cleanedTarget}'. Please choose one.`;

            } else {
              actions.push({
                type   : 'open_modal',
                modal  : 'ticket',
                payload: {},
                label  : 'Open blank ticket form'
              });
              responseMessage=`I could not validate '${cleanedTarget}'. Open a blank ticket form or refine the target.`;
            }
          }

          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;
          this.chatGptForm.controls["response"].setValue(responseMessage);
          this.pendingActions=this.uniqueActions(actions);
          this.auditAssistantDecision('forced_raise_ticket');
          this.continueBatchQueueIfNeeded();
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          this.pendingActions=[];
          this.showChatBorder=false;

          //CRN_20260223 - TopbarComponent now displays error messages
          // this.alertColourProgress=AlertClassColour.Red;
          // this.progressInformation=error.message;
          this.continueBatchQueueIfNeeded();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private handleForcedGlobalSearch(term: string) {
    try {
      const query=(term ?? '').trim();

      if (!query)
        return;
        
      const requestToken      =this.createRequestToken();
      this.showChatBorder     =true;
      this.alertColourProgress=AlertClassColour.Green;
      this.progressInformation="Searching SureSIM...";
      this.chatGptForm.controls["response"].setValue(this.progressInformation);

      this.sureSimSearchService.globalSearch(query)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: ({ actions, companyCount, simCount, ticketCount, truncated, userCount }) => {
          if (!this.isActiveRequestToken(requestToken))
            return;

          this.pendingActions     =actions;
          this.showChatBorder     =false;
          this.alertColourProgress=AlertClassColour.Green;
          this.progressInformation=this.initialStatus;

          if (this.pendingActions.length > 0) {
            const summaryParts: string[]=[];
            if (companyCount>0)
              summaryParts.push(`${companyCount} compan${companyCount===1 ? 'y' : 'ies'}`);

            if (userCount>0)
              summaryParts.push(`${userCount} user${userCount===1 ? '' : 's'}`);

            if (simCount>0)
              summaryParts.push(`${simCount} SIM${simCount===1 ? '' : 's'}`);

            if (ticketCount>0)
              summaryParts.push(`${ticketCount} ticket${ticketCount===1 ? '' : 's'}`);

            const summary=summaryParts.join(', ');
            this.chatGptForm.controls["response"].setValue(`I found ${summary} for '${query}'. Choose an action.`);

          } else {
            this.chatGptForm.controls["response"].setValue(`I could not find '${query}' in SureSIM.`);
          }

          this.appendRefineSearchNote(truncated);
          this.auditAssistantDecision('forced_global_search');
          this.continueBatchQueueIfNeeded();
        },
        error: error => {
          if (!this.isActiveRequestToken(requestToken))
            return;
          
          this.pendingActions=[];
          this.showChatBorder=false;

          //CRN_20260223 - TopbarComponent now displays error messages
          // this.alertColourProgress=AlertClassColour.Red;
          // this.progressInformation=error.message;
          this.continueBatchQueueIfNeeded();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public executeAction(action: ChatGptAction) {
    try {
      if (this.requiresActionConfirmation(action) && this.pendingConfirmationAction !== action) {
        this.pendingConfirmationAction=action;
        this.confirmationReason       =this.actionConfirmationReason(action);
        return;
      }

      this.pushAssistantHistory({
        id         : this.createHistoryId(),
        timestamp  : new Date().toISOString(),
        prompt     : this.userPromptRaw || '',
        intent     : this.activeIntentStage,
        actionLabel: this.actionLabel(action),
        action     : action
      });

      this.auditAssistantDecision('action_execute');
      this.traceExplainability('action.execute', this.actionLabel(action));
      this.pendingConfirmationAction=undefined;
      this.confirmationReason       ="";

      switch (action.type) {
        case 'navigate':
          this.navigateBasedOnCommand(action.destination, action.payload, !this.copilotMode);
          break;
        case 'open_modal':
          this.assistantActionRequested.emit(action);
          if (!this.copilotMode)
            this.closeModalWindow();

          break;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public runHistoryAction(entry: ChatGptActionHistoryEntry) {
    try {
      if (entry.action) {
        this.executeAction(entry.action);

      } else if (entry.prompt) {
        this.chatGptForm.get('prompt')?.setValue(entry.prompt);
        this.chatGptFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearPendingActions() {
    try {
      this.pendingActions           =[];
      this.focusedActionCardIndex   =0;
      this.pendingConfirmationAction=undefined;
      this.confirmationReason       ="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get visiblePendingActions(): ChatGptAction[] {
    try {
      return this.pendingActions.filter(action => this.canRenderAssistantAction(action));
    }
    catch {
      return this.pendingActions;
    }
  }

  public get pendingActionCards(): ChatGptActionCard[] {
    try {
      const memoKey=JSON.stringify({
        actions: this.visiblePendingActions,
        pinned : Array.from(this.pinnedActionKeys),
        order  : this.pinnedActionOrder
      });

      if (this.cardsMemoKey===memoKey && this.cardsMemoValue)
        return this.cardsMemoValue;

      const built        =this.buildActionCards(this.visiblePendingActions);
      this.cardsMemoKey  =memoKey;
      this.cardsMemoValue=built;
      return built;
    }
    catch {
      return [];
    }
  }

  public get intentChips(): ChatGptIntentChip[] {
    try {
      const availableKinds=this.pendingActionCards.map(x => x.kind);

      const chips: ChatGptIntentChip[]=['all'];

      (['company', 'user', 'sim', 'ticket'] as ChatGptIntentChip[]).forEach(kind => {
        if (availableKinds.includes(kind))
          chips.push(kind);
      });
      return chips;
    }
    catch {
      return ['all'];
    }
  }

  public selectIntentChip(chip: ChatGptIntentChip) {
    try {
    this.selectedIntentChip    =chip;
    this.focusedActionCardIndex=0;
    this.saveAssistantPreferences();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get filteredActionCards(): ChatGptActionCard[] {
    try {
    let cards=this.pendingActionCards;

    if (this.selectedIntentChip !== 'all')
      cards=cards.filter(x => x.kind===this.selectedIntentChip);
      
    return cards;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public get pinnedActionCards(): ChatGptActionCard[] {
    try {
    const cards=this.filteredActionCards.filter(x => x.pinned);
    return cards.sort((a, b) => this.pinnedOrderIndex(a.key) - this.pinnedOrderIndex(b.key));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public get unpinnedActionCards(): ChatGptActionCard[] {
    try {
    return this.filteredActionCards.filter(x => !x.pinned);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public get bestActionCard(): ChatGptActionCard | undefined {
    try {
    const cards=this.unpinnedActionCards;
    return cards[0];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  public get otherActionCards(): ChatGptActionCard[] {
    try {
    return this.unpinnedActionCards.slice(1);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public get responseSizeMode(): 'expanded' | 'timeline' | 'timeline_dense' | 'compact' {
    try {
      if (this.hasBelowResponsePanelsExceptTimeline)
        return 'compact';

      if (this.assistantActionHistory.length > 3)
        return 'timeline_dense';
        
      if (this.assistantActionHistory.length > 0)
        return 'timeline';
        
      return 'expanded';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'expanded';
    }
  }

  private get hasBelowResponsePanelsExceptTimeline(): boolean {
    try {
      return this.queuedBatchPrompts.length > 0
        || !!this.pendingConfirmationAction
        || this.filteredActionCards.length > 0
        || this.showInsightsPanel
        || (this.showAssistantDiagnostics && this.assistantDiagnosticsOpen)
        || (this.explainabilityMode && this.explainabilityTrace.length > 0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private syncResponseHeightToFooter(): void {
    try {
      const responseElement=document.getElementById('response-field') as HTMLTextAreaElement | null;
      if (!responseElement) {
        return;
      }
      const modalBody  =responseElement.closest('.modal-body') as HTMLElement | null;
      const dynamicMode=!this.hasBelowResponsePanelsExceptTimeline;

      if (!dynamicMode) {
        if (this.lastDynamicResponseMode !== false) {
          responseElement.style.removeProperty('height');
          responseElement.style.removeProperty('min-height');
          responseElement.style.removeProperty('max-height');
          modalBody?.style.removeProperty('overflow-y');
          this.lastDynamicResponseHeight=undefined;
          this.lastDynamicResponseMode=false;
        }
        return;
      }

      const modalContent=responseElement.closest('.modal-content');
      const modalFooter =modalContent?.querySelector('.modal-footer') as HTMLElement | null;

      if (!modalFooter)
        return;

      const responseTop=responseElement.getBoundingClientRect().top;
      const footerTop  =modalFooter.getBoundingClientRect().top;
      const nextHeight =Math.max(130, Math.floor(footerTop - responseTop - 18));

      if (this.lastDynamicResponseHeight===nextHeight && this.lastDynamicResponseMode===true)
        return;

      responseElement.style.height   =`${nextHeight}px`;
      responseElement.style.minHeight=`${nextHeight}px`;
      responseElement.style.maxHeight=`${nextHeight}px`;

      if (modalBody) {
        if (this.lastDynamicResponseMode !== true)
          modalBody.scrollTop=0;
          
        modalBody.style.overflowY='hidden';
      }
      this.lastDynamicResponseHeight=nextHeight;
      this.lastDynamicResponseMode  =true;
    }
    catch(e) {
      // this.exceptionsService.handleException(<Error>e);
      //CRN_20260224 - Ignore
    }
  }

  public isFocusedCard(card: ChatGptActionCard): boolean {
    try {
      const cards  =this.filteredActionCards;
      const focused=cards[this.focusedActionCardIndex];

      return !!focused && focused.key===card.key;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public focusCard(card: ChatGptActionCard) {
    try {
      const index                =this.filteredActionCards.findIndex(x => x.key === card.key);
      this.focusedActionCardIndex=index >= 0 ? index : 0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCopilotModeChanged(value: boolean) {
    try {
      this.copilotMode=value;
      this.saveAssistantPreferences();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onExplainabilityModeChanged(value: boolean) {
    try {
      this.explainabilityMode=value;
      this.saveAssistantPreferences();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get stageSteps(): ChatGptStageStep[] {
    try {
      const order: Array<{ key: ChatGptIntentStage; label: string }>= [
        { key: 'company',      label: 'Company' },
        { key: 'user',         label: 'User' },
        { key: 'sim',          label: 'SIM' },
        { key: 'ticket',       label: 'Ticket' },
        { key: 'raise_ticket', label: 'Raise' },
        { key: 'search',       label: 'Find' },
        { key: 'model',        label: 'AI' },
      ];
      return order.map((x, index) => ({
        key      : x.key,
        label    : x.label,
        active   : this.showChatBorder && this.activeIntentStage === x.key,
        completed: !this.showChatBorder && this.activeIntentStage !== 'idle' && this.stageOrder(this.activeIntentStage) >= index
      }));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public actionLabel(action: ChatGptAction): string {
    try {
      if (action.label?.trim())
        return action.label.trim();

      if (action.type==='navigate')
        return `Open ${action.destination}`;

      return `Open ${action.modal.replace('_', ' ')}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'Run Action';
    }
  }

  public get showAssistantDiagnostics(): boolean {
    try {
      return localStorage.getItem('SureSimAssistantDebug')==='true';
    }
    catch {
      return false;
    }
  }

  public diagnosticsSummary(): string {
    try {
      const parts=[
        `prompt: ${this.userPromptRaw || '(none)'}`,
        `intent.company: ${this.forcedCompanyIntentName ?? '-'}`,
        `intent.user: ${this.forcedUserIntent ? `${this.forcedUserIntent.userType}:${this.forcedUserIntent.userName}` : '-'}`,
        `intent.sim: ${this.forcedSimIntent ?? '-'}`,
        `intent.ticket: ${this.forcedTicketIntentQuery ?? '-'}`,
        `intent.raiseTicketFor: ${this.forcedRaiseTicketFor ?? '-'}`,
        `actions.visible: ${this.visiblePendingActions.length}`,
        `actions.total: ${this.pendingActions.length}`
      ];
      return parts.join('\n');
    }
    catch {
      return '';
    }
  }

  public get assistantInsights(): ChatGptInsightsSummary {
    try {
      const records=this.chatGptService.readAudit(this.curUser?.userId);
      type  NewType=ChatGptInsightsSummary;

      const summary: NewType={
        totalEvents: records.length,
        topEvents: []
      };

      const map=new Map<string, number>();
      records.forEach(r => {
        const key=(r?.eventType ?? 'unknown').toString();
        map.set(key, (map.get(key) ?? 0) + 1);
      });

      summary.topEvents=Array.from(map.entries())
        .sort((a, b) => b[1] - a[1])
        .slice(0, 5)
        .map(([eventType, count]) => ({ eventType, count }));
      return summary;
    }
    catch {
      return { totalEvents: 0, topEvents: [] };
    }
  }

  private buildContextualPrompt(promptText: string): string {
    try {
      const routeBase     =(this.router.url ?? '').split('?')[0].toLowerCase();
      const pageLabel     =ChatGptModalFormComponent.routePageLabelMap[routeBase] ?? routeBase;
      const contextualData=[
        `userId=${this.curUser?.userId ?? -1}`,
        `companyId=${this.curUser?.companyId ?? -1}`,
        `topBarCompanyId=${this.latestTopBarCompanyId ?? ''}`,
        `page=${pageLabel}`,
        `route=${this.router.url ?? ''}`,
        `copilotMode=${this.copilotMode}`,
      ];

      const historyLines=this.modelConversationHistory
        .map(h => `User: ${h.userPrompt}\nAssistant: ${h.assistantReply}`)
        .join('\n');

      const parts=[
        ChatGptModalFormComponent.responseJsonHint,
        `${ChatGptModalFormComponent.contextLinePrefix} ${contextualData.join('; ')}`,
      ];

      if (historyLines)
        parts.push(`[Conversation History]\n${historyLines}`);

      parts.push(`${ChatGptModalFormComponent.promptLinePrefix} ${promptText}`);

      return parts.join('\n\n');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return promptText;
    }
  }

  private canRenderAssistantAction(action: ChatGptAction): boolean {
    try {
      if (action.type !== 'open_modal')
        return true;

      return this.chatGptService.canExecuteModalAction(action.modal);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private buildActionCards(actions: ChatGptAction[]): ChatGptActionCard[] {
    try {
      const grouped=new Map<string, ChatGptActionCard>();
  
      actions.forEach(action => {
        const key     =this.actionCardKey(action);
        const existing=grouped.get(key);

        if (existing) {
          existing.actions.push(action);
          return;
        }

        const actionKey=this.actionItemKey(action);
        grouped.set(key, {
          key         : key,
          kind        : this.actionCardKind(action),
          title       : this.actionCardTitle(action),
          previewItems: this.actionCardPreviewItems(action),
          confidence  : this.actionCardConfidence(action),
          pinned      : this.pinnedActionKeys.has(actionKey),
          actions     : [action]
        });
      });
  
      const cards=Array.from(grouped.values());

      cards.forEach(card => {
        card.actions=[...card.actions].sort((a, b) => {
          const aPinned=this.isPinnedActionItem(a);
          const bPinned=this.isPinnedActionItem(b);

          if (aPinned !== bPinned)
            return aPinned ? -1 : 1;
            
          const aOrder=this.actionDisplayOrder(a);
          const bOrder=this.actionDisplayOrder(b);

          if (aOrder !== bOrder)
            return aOrder - bOrder;
            
          if (a.type !== b.type)
            return a.type==='open_modal' ? -1 : 1;

          return this.actionLabel(a).localeCompare(this.actionLabel(b));
        });
        card.pinned=card.actions.some(x => this.isPinnedActionItem(x));
      });
  
      return cards
             .sort((a, b) => {
               if (a.pinned !== b.pinned)
                 return a.pinned ? -1 : 1;
                 
               if (a.pinned && b.pinned)
                 return this.pinnedOrderIndex(a.key) - this.pinnedOrderIndex(b.key);
                 
               return this.confidenceWeight(b.confidence) - this.confidenceWeight(a.confidence);
             });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private actionCardKey(action: ChatGptAction): string {
    try {
      return this.sureSimSearchService.actionCardKey(action);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  private actionCardTitle(action: ChatGptAction): string {
    try {
      switch (this.actionCardKind(action)) {
        case 'company':
          return 'Company';
        case 'user':
          return 'User';
        case 'sim':
          return 'SIM';
        case 'ticket':
          return 'Ticket';
        default:
          return 'Company';
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'Company';
    }
  }

  private actionCardKind(action: ChatGptAction): ChatGptIntentChip {
    try {
      return this.sureSimSearchService.actionCardKind(action);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'company';
    }
  }

  private actionCardPreviewItems(action: ChatGptAction): string[] {
    try {
      return this.sureSimSearchService.actionCardPreviewItems(action);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private actionCardConfidence(action: ChatGptAction): ChatGptConfidence {
    try {
      const payload=action.payload;

      if (payload?.ticketId || payload?.iccid || payload?.userId || payload?.companyId)
        return 'high';
        
      if (payload?.userName || payload?.companyName)
        return 'medium';
        
      return 'low';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 'low';
    }
  }

  private confidenceWeight(value: ChatGptConfidence): number {
    try {
      switch (value) {
        case 'high'  : return 3;
        case 'medium': return 2;
        default      : return 1;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 1;
    }
  }

  private actionItemKey(action: ChatGptAction): string {
    try {
      return JSON.stringify({
        type       : action.type,
        destination: action.type==='navigate' ? action.destination : undefined,
        modal      : action.type==='open_modal' ? action.modal : undefined,
        payload    : action.payload ?? {},
        label      : action.label ?? ''
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public isPinnedActionItem(action: ChatGptAction): boolean {
    try {
      return this.pinnedActionKeys.has(this.actionItemKey(action));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public togglePinnedAction(card: ChatGptActionCard) {
    try {
      const cardIsPinned=card.actions.some(x => this.pinnedActionKeys.has(this.actionItemKey(x)));

      if (cardIsPinned) {
        card.actions.forEach(action => this.pinnedActionKeys.delete(this.actionItemKey(action)));
        this.pinnedActionOrder=this.pinnedActionOrder.filter(x => x !== card.key);

      } else {
        card.actions.forEach(action => this.pinnedActionKeys.add(this.actionItemKey(action)));

        if (!this.pinnedActionOrder.includes(card.key))
          this.pinnedActionOrder.push(card.key);
      }

      this.savePinnedActionKeys();
      this.cardsMemoKey=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onPinnedDragStart(event: DragEvent, card: ChatGptActionCard) {
    try {
      if (!event.dataTransfer)
        return;
        
      event.dataTransfer.effectAllowed='move';
      event.dataTransfer.setData('text/plain', card.key);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onPinnedDragOver(event: DragEvent) {
    try {
      event.preventDefault();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onPinnedDrop(event: DragEvent, targetCard: ChatGptActionCard) {
    try {
      event.preventDefault();
      const sourceKey=event.dataTransfer?.getData('text/plain');

      if (!sourceKey || sourceKey === targetCard.key)
        return;

      const sourceIndex=this.pinnedActionOrder.indexOf(sourceKey);
      const targetIndex=this.pinnedActionOrder.indexOf(targetCard.key);

      if (sourceIndex < 0 || targetIndex < 0)
        return;

      const next=[...this.pinnedActionOrder];
      const [moved]=next.splice(sourceIndex, 1);
      next.splice(targetIndex, 0, moved);
      this.pinnedActionOrder=next;
      this.savePinnedActionKeys();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private pinnedActionStorageKey(): string {
    try {
      return `${StorageValues.sureSimAssistantPinnedActions_}${this.curUser?.userId ?? 0}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private loadPinnedActionKeys() {
    try {
      const key=this.pinnedActionStorageKey();
      let   raw=localStorage.getItem(key);

      if (raw===null) {
        const legacyRaw=localStorage.getItem(StorageValues.sureSimAssistantPinnedActionConfig);

        if (legacyRaw !== null) {
          raw=legacyRaw;
          localStorage.setItem(key, legacyRaw);
          localStorage.removeItem(StorageValues.sureSimAssistantPinnedActionConfig);
        }
      }

      const config          =raw ? JSON.parse(raw) : undefined;
      const order           =Array.isArray(config?.order) ? config.order as string[] : [];
      const keys            =Array.isArray(config?.keys) ? config.keys as string[] : [];
      this.pinnedActionOrder=order;
      this.pinnedActionKeys =new Set(keys.length > 0 ? keys : order);
    }
    catch {
      this.pinnedActionKeys =new Set<string>();
      this.pinnedActionOrder=[];
    }
  }

  private savePinnedActionKeys() {
    try {
      const keys=Array.from(this.pinnedActionKeys).slice(0, 100);
      const availableCards=this.pendingActionCards.map(x => x.key);
      const order=this.pinnedActionOrder.filter(x => availableCards.includes(x)).slice(0, 100);
      localStorage.setItem(this.pinnedActionStorageKey(), JSON.stringify({ keys, order }));
    }
    catch(e) {
      //CRN_20260224 - Ignore
      // this.exceptionsService.handleException(<Error>e);
    }
  }

  private assistantPreferenceStorageKey(): string {
    try {
      return `${StorageValues.sureSimAssistantPrefs_}${this.curUser?.userId ?? 0}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private loadAssistantPreferences() {
    try {
      const raw              =localStorage.getItem(this.assistantPreferenceStorageKey());
      const prefs            =raw ? JSON.parse(raw) : {};
      const chip             =prefs?.selectedIntentChip as ChatGptIntentChip;
      this.selectedIntentChip=['all', 'company', 'user', 'sim', 'ticket'].includes(chip) ? chip : 'all';
      this.copilotMode       =prefs?.copilotMode !== false;
      this.explainabilityMode=Boolean(prefs?.explainabilityMode);
      this.pinnedDocked      =prefs?.pinnedDocked !== false;
      this.tipsHidden        =prefs?.tipsHidden === true;
    }
    catch {
      this.selectedIntentChip='all';
      this.copilotMode       =true;
      this.explainabilityMode=false;
      this.pinnedDocked      =true;
      this.tipsHidden        =false;
    }
  }

  public wasOpenAndDocked(): boolean {
    try {
      const raw  =localStorage.getItem(this.assistantPreferenceStorageKey());
      const prefs=raw ? JSON.parse(raw) : {};

      return Boolean(prefs?.assistantOpen) && prefs?.pinnedDocked !== false;
    }
    catch {
      return false;
    }
  }

  private saveAssistantPreferences() {
    try {
      localStorage.setItem(this.assistantPreferenceStorageKey(), JSON.stringify({
        selectedIntentChip: this.selectedIntentChip,
        copilotMode       : this.copilotMode,
        explainabilityMode: this.explainabilityMode,
        pinnedDocked      : this.pinnedDocked,
        assistantOpen     : this.assistantOpen,
        tipsHidden        : this.tipsHidden
      }));
    }
    catch(e) {
      //CRN_20260224 - Ignore
      // this.exceptionsService.handleException(<Error>e);
    }
  }

  private pinnedOrderIndex(key: string): number {
    try {
      const index=this.pinnedActionOrder.indexOf(key);

      return index >= 0 ? index : Number.MAX_SAFE_INTEGER;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return Number.MAX_SAFE_INTEGER;
    }
  }

  private executePreferredFocusedAction() {
    try {
      const card          =this.filteredActionCards[this.focusedActionCardIndex] ?? this.bestActionCard;
      const formAction    =card?.actions.find(x => x.type === 'open_modal');
      const navigateAction=card?.actions.find(x => x.type === 'navigate');
      const action        =formAction ?? navigateAction;

      if (action)
        this.executeAction(action);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private requiresActionConfirmation(action: ChatGptAction): boolean {
    try {
      const payload=action.payload;

      if (action.type==='open_modal' && (action.modal==='ticket' || action.modal==='provision'))
        return !payload?.ticketId && !payload?.companyId && !payload?.userId && !payload?.iccid;
        
      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private actionConfirmationReason(action: ChatGptAction): string {
    try {
      if (action.type==='open_modal' && action.modal==='ticket')
        return 'This opens a new ticket flow without a locked entity. Confirm before continuing.';
        
      if (action.type==='open_modal' && action.modal==='provision')
        return 'This starts provisioning flow. Confirm to avoid provisioning the wrong target.';
      
      return 'Please confirm this action.';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  public confirmPendingAction() {
    try {
      if (!this.pendingConfirmationAction)
        return;
        
      const action                  =this.pendingConfirmationAction;
      this.pendingConfirmationAction=undefined;
      this.confirmationReason       ="";
      this.executeAction(action);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cancelPendingConfirmation() {
    try {
      this.pendingConfirmationAction=undefined;
      this.confirmationReason       ="";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private createRequestToken(): number {
    try {
      this.latestRequestToken++;
      return this.latestRequestToken;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return -1;
    }
  }

  private isActiveRequestToken(token: number): boolean {
    try {
      return token===this.latestRequestToken;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private traceExplainability(step: string, details: string) {
    try {
      if (!this.explainabilityMode)
        return;
        
      this.explainabilityTrace=[
        ...this.explainabilityTrace,
        { step: step, details: details, timestamp: new Date().toISOString() }
      ].slice(-30);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setIntentStage(stage: ChatGptIntentStage) {
    try {
      this.activeIntentStage=stage;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private stageOrder(stage: ChatGptIntentStage): number {
    try {
      const order: ChatGptIntentStage[]=['company', 'user', 'sim', 'ticket', 'raise_ticket', 'search', 'model'];
      const index=order.indexOf(stage);

      return index < 0 ? -1 : index;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return -1;
    }
  }

  private loadOnboardingState() {
    try {
      this.onboardingVisible  =!this.tipsHidden;
      this.onboardingStepIndex=0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get onboardingSteps(): string[] {
    try {
      return [
        "<strong>General Search</strong> 'find john', 'search for SureSIM' or 'look for [<em>ICCID</em>]'",
        "<strong>Company Search</strong> 'find company [<em>Company name</em>]'",
        "<strong>SIM Search</strong> 'find sim [<em>ICCID</em>]'",
        "<strong>Ticket Search</strong> 'find ticket [<em>Company name, username, part of name</em>]'",
        "<strong>User Search</strong> 'find user [<em>Username, part of name...</em>]'",
        "Pin found entities to keep results at the top of suggested actions",
      ];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public nextOnboardingStep() {
    try {
      if (this.onboardingStepIndex < this.onboardingSteps.length - 1)
        this.onboardingStepIndex++;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public previousOnboardingStep() {
    try {
      if (this.onboardingStepIndex > 0)
        this.onboardingStepIndex--;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public dismissOnboarding() {
    try {
      this.onShowTipsChanged(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onShowTipsChanged(value: boolean): void {
    try {
      this.onboardingVisible=value;
      this.tipsHidden       =!value;

      if (value)
        this.onboardingStepIndex=0;

      this.saveAssistantPreferences();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public get suggestedPrompts(): string[] {
    try {
      // const url=(this.router.url ?? '').toLowerCase();

      // if (url.includes('/companies'))
      //   return ['Find [x]', 'Find company [x]', 'Find ticket [x]', 'Find user [x]', 'Show manage SIMs'];

      // if (url.includes('/provisioning/devices-allocated'))
      //   return ['Find [x]', 'Find company [x]', 'Find SIM [x]', 'Find ticket [x]', 'Manage SIM [x]'];

      // if (url.includes('/provisioning/devices-available') || url.includes('/provisioning/esim-provision'))
      //   return ['Find [x]', 'Find company [x]', 'Find SIM [x]', 'Find user [x]', 'Show manage SIMs'];

      // if (url.includes('/support'))
      //   return ['Find [x]', 'Find company [x]', 'Find ticket [x]', 'Find user [x]', 'Raise ticket for [issue]'];

      // if (url.includes('/timeline'))
      //   return ['Find [x]', 'Find company [x]', 'Find SIM [x]', 'Find user [x]', 'Show manage SIMs'];

      // if (url.includes('/users'))
      //   return ['Find [x]', 'Find company [x]', 'Find SIM [x]', 'Find ticket [x]', 'Find user [x]'];

      return ['Find [x]', 'Find company [x]', 'Find SIM [x]', 'Find ticket [x]', 'Find user [x]'];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  public applySuggestedPrompt(prompt: string): void {
    try {
      this.chatGptForm.get('prompt')?.setValue(prompt);
      this.onPromptInput(prompt);

      const match=prompt.match(/\[([^\]]+)\]/);

      if (match) {
        const start=prompt.indexOf(match[0]);
        const end  =start + match[0].length;

        setTimeout(() => {
          const el=document.getElementById('prompt-field') as HTMLTextAreaElement | null;
          if (el) {
            el.focus();
            el.setSelectionRange(start, end);
          }
        }, 0);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private createHistoryId(): string {
    try {
      return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  private recordPromptHistory(intent: ChatGptIntentStage, prompt: string) {
    try {
      this.pushAssistantHistory({
        id       : this.createHistoryId(),
        timestamp: new Date().toISOString(),
        prompt   : prompt,
        intent   : intent,
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private pushAssistantHistory(entry: ChatGptActionHistoryEntry) {
    try {
      this.assistantActionHistory=[entry, ...this.assistantActionHistory].slice(0, 25);
      this.saveAssistantTimeline();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private assistantTimelineStorageKey(): string {
    try {
      return `${StorageValues.sureSimAssistantTimeline_}${this.curUser?.userId ?? 0}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private loadAssistantTimeline(): void {
    try {
      if (!this.chatGptRetainSessionHistory || this.assistantActionHistory.length > 0)
        return;

      const raw   =sessionStorage.getItem(this.assistantTimelineStorageKey());
      const parsed=raw ? JSON.parse(raw) : [];

      this.assistantActionHistory=Array.isArray(parsed)
                                  ? (<ChatGptActionHistoryEntry[]>parsed).filter(x => !!x?.id && !!x?.prompt).slice(0, 25)
                                  : [];
    }
    catch {
      this.assistantActionHistory=[];
    }
  }

  private saveAssistantTimeline(): void {
    try {
      const key=this.assistantTimelineStorageKey();

      if (!this.chatGptRetainSessionHistory) {
        sessionStorage.removeItem(key);
        return;
      }

      sessionStorage.setItem(key, JSON.stringify(this.assistantActionHistory));
    }
    catch {
      //CRN_20260925 - Ignore
    }
  }

  private pushModelConversationHistory(userPrompt: string, assistantReply: string) {
    try {
      this.modelConversationHistory=[
        ...this.modelConversationHistory,
        { assistantReply: (assistantReply ?? '').slice(0, 500), userPrompt: userPrompt ?? '' }
      ].slice(-5);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private sanitizeLegacyResponse(response: string): string {
    try {
      return response.replace(/<command>[\s\S]*?<\/command>/ig, '').trim();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return response;
    }
  }

  private tryParseStructuredAiResponse(response: string): ChatGptResponse | null {
    try {
      const payloadText=this.tryExtractJsonPayload(response);

      if (!payloadText)
        return null;

      const parsed: unknown=this.parseJsonWithRepair(payloadText);

      if (!parsed || typeof parsed !== 'object')
        return null;

      const structured   =parsed as Partial<ChatGptResponse>;
      const reply        =typeof structured.reply==='string' ? structured.reply.trim() : '';
      const actionsSource=Array.isArray(structured.actions) ? structured.actions : [];

      const actions: ChatGptAction[]=[];

      for (const action of actionsSource) {
        if (!action || typeof action !== 'object')
          continue;

        const maybeAction=action as ChatGptActionLegacy;
        const type       =(maybeAction.type ?? '').toString().trim().toLowerCase();
        const destination=(maybeAction.destination ?? '').toString().trim().toLowerCase();
        const modal      =(maybeAction.modal ?? '').toString().trim().toLowerCase();
        const label      =typeof maybeAction.label === 'string' ? maybeAction.label.trim() : undefined;
        const payload    =this.parseActionPayload(maybeAction.payload);

        if (type==='navigate' && destination) {
          actions.push({ type: 'navigate', destination, payload, label });

        } else if (type==='open_modal' && this.isSupportedModalAction(modal)) {
          actions.push({ type: 'open_modal', modal, payload, label });
        }
      }

      return { reply, actions: this.enrichNavigateActions(actions) };
    }
    catch {
      return this.tryParseHeuristicStructuredResponse(response);
    }
  }

  private tryExtractJsonPayload(response: string): string | null {
    try {
      const fencedJsonMatch=response.match(/```json\s*([\s\S]*?)\s*```/i);

      if (fencedJsonMatch?.[1])
        return fencedJsonMatch[1].trim();

      const fencedAnyMatch=response.match(/```\s*([\s\S]*?)\s*```/);

      if (fencedAnyMatch?.[1]) {
        const fencedText=fencedAnyMatch[1].trim();
        
        if (fencedText.startsWith('{') && fencedText.endsWith('}'))
          return fencedText;
      }

      const body=response.trim();

      if (body.startsWith('{'))
        return body;

      return null;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return null;
    }
  }

  private parseActionPayload(payload: unknown): ChatGptActionPayload | undefined {
    try {
      if (!payload || typeof payload !== 'object')
        return undefined;

      const source      =payload as Record<string, unknown>;
      const companyId   =this.toOptionalNumber(source['companyId']);
      const companyName =typeof source['companyName'] === 'string' ? source['companyName'].trim() : undefined;
      const userId      =this.toOptionalNumber(source['userId']);
      const userNameRaw =typeof source['userName']==='string'
                         ? source['userName']
                         : (typeof source['username'] === 'string' ? source['username'] : undefined);
      const userName    =userNameRaw?.trim();
      const userEmail   =typeof source['userEmail'] === 'string' ? source['userEmail'].trim() : undefined;
      const deviceId    =this.toOptionalNumber(source['deviceId']);
      const deviceTypeId=this.toOptionalNumber(source['deviceTypeId']);
      const iccid       =typeof source['iccid'] === 'string' ? source['iccid'].trim() : undefined;
      const ticketId    =this.toOptionalNumber(source['ticketId']);
      const entityStatus=typeof source['entityStatus'] === 'string' ? source['entityStatus'].trim() : undefined;
      const ticketTitle =typeof source['ticketTitle'] === 'string' ? source['ticketTitle'].trim() : undefined;

      const result: ChatGptActionPayload={};

      if (companyId !== undefined)
        result.companyId=companyId;
        
      if (companyName)
        result.companyName=companyName;
      
      if (userId !== undefined)
        result.userId=userId;
      
      if (userName)
        result.userName=userName;
      
      if (userEmail)
        result.userEmail=userEmail;
      
      if (deviceId !== undefined)
        result.deviceId=deviceId;
      
      if (deviceTypeId !== undefined)
        result.deviceTypeId=deviceTypeId;
      
      if (iccid)
        result.iccid=iccid;
      
      if (ticketId !== undefined)
        result.ticketId=ticketId;
      
      if (entityStatus)
        result.entityStatus=entityStatus;
      
      if (ticketTitle)
        result.ticketTitle=ticketTitle;

      return Object.keys(result).length > 0 ? result : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private toOptionalNumber(value: unknown): number | undefined {
    try {
      const parsed=Number(value);
      return Number.isFinite(parsed) ? parsed : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private parseJsonWithRepair(payloadText: string): unknown {
    try {
      return JSON.parse(payloadText);
    }
    catch {
      const repaired=this.repairLikelyTruncatedJson(payloadText);
      return JSON.parse(repaired);
    }
  }

  private repairLikelyTruncatedJson(payloadText: string): string {
    try {
      let repaired   =this.stripDanglingJsonTail(payloadText.trim());
      let openCurly  =0;
      let closeCurly =0;
      let openSquare =0;
      let closeSquare=0;
  
      for (const ch of repaired) {
        if (ch === '{') {
          openCurly++;

        } else if (ch === '}') {
          closeCurly++;

        } else if (ch === '[') {
          openSquare++;

        } else if (ch === ']') {
          closeSquare++;
        }
      }
  
      if (openSquare > closeSquare)
        repaired+=']'.repeat(openSquare - closeSquare);
        
      if (openCurly > closeCurly)
        repaired+='}'.repeat(openCurly - closeCurly);
  
      return repaired;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return payloadText;
    }
  }

  private stripDanglingJsonTail(payloadText: string): string {
    try {
      let text=payloadText;
  
      text=text.replace(/,\s*$/g, '');
      text=text.replace(/:\s*$/g, '');
      text=text.replace(/,\s*"[^"]*"\s*:\s*$/g, '');
      text=text.replace(/"[^"]*"\s*:\s*$/g, '');
      text=text.replace(/:\s*"[^"]*$/g, '');
      text=text.replace(/,\s*"[^"]*$/g, '');
      text=text.replace(/,\s*$/g, '');
  
      return text;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return payloadText;
    }
  }

  private tryParseHeuristicStructuredResponse(response: string): ChatGptResponse | null {
    try {
      const reply=this.extractHeuristicReply(response);
      const actions: ChatGptAction[]=[];

      const navigateMatches=response.matchAll(/"type"\s*:\s*"navigate"[\s\S]*?"destination"\s*:\s*"([^"]+)"/gi);

      for (const match of navigateMatches) {
        const destination=(match[1] ?? '').trim().toLowerCase();
        if (destination)
          actions.push({ type: 'navigate', destination });
      }

      const openModalMatch=response.match(/"type"\s*:\s*"open_modal"[\s\S]*?"modal"\s*:\s*"([^"]+)"/i);

      if (openModalMatch?.[1]) {
        const modal=openModalMatch[1].trim().toLowerCase();

        if (this.isSupportedModalAction(modal)) {
          const payload=this.extractHeuristicPayload(response);
          actions.push({ type: 'open_modal', modal, payload });
        }
      }

      if (!reply && actions.length===0)
        return null;

      return { reply, actions: this.enrichNavigateActions(actions) };
    }
    catch {
      return null;
    }
  }

  private extractHeuristicReply(response: string): string {
    const replyMatch=response.match(/"reply"\s*:\s*"([\s\S]*?)"\s*,\s*"actions"/i)
                   ?? response.match(/"reply"\s*:\s*"([\s\S]*?)"/i);
    const replyRaw=(replyMatch?.[1] ?? '').trim();
    return replyRaw
      .replace(/\\"/g, '"')
      .replace(/\\n/g, '\n')
      .replace(/\\t/g, '\t');
  }

  private extractHeuristicPayload(response: string): ChatGptActionPayload | undefined {
    try {
	
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
    const payload: ChatGptActionPayload={};

    const companyId   =this.extractHeuristicNumber(response, 'companyId');
    const companyName =this.extractHeuristicString(response, 'companyName');
    const userId      =this.extractHeuristicNumber(response, 'userId');
    const userName    =this.extractHeuristicString(response, 'userName');
    const deviceId    =this.extractHeuristicNumber(response, 'deviceId');
    const deviceTypeId=this.extractHeuristicNumber(response, 'deviceTypeId');
    const iccid       =this.extractHeuristicString(response, 'iccid');
    const ticketId    =this.extractHeuristicNumber(response, 'ticketId');
    const userEmail   =this.extractHeuristicString(response, 'userEmail');
    const entityStatus=this.extractHeuristicString(response, 'entityStatus');
    const ticketTitle =this.extractHeuristicString(response, 'ticketTitle');

    if (companyId !== undefined)
      payload.companyId=companyId;

    if (companyName)
      payload.companyName=companyName;

    if (userId !== undefined)
      payload.userId=userId;

    if (userName)
      payload.userName=userName;

    if (deviceId !== undefined)
      payload.deviceId=deviceId;

    if (deviceTypeId !== undefined)
      payload.deviceTypeId=deviceTypeId;

    if (iccid)
      payload.iccid=iccid;

    if (ticketId !== undefined)
      payload.ticketId=ticketId;

    if (userEmail)
      payload.userEmail=userEmail;

    if (entityStatus)
      payload.entityStatus=entityStatus;

    if (ticketTitle)
      payload.ticketTitle=ticketTitle;

    return Object.keys(payload).length > 0 ? payload : undefined;
  }

  private enrichNavigateActions(actions: ChatGptAction[]): ChatGptAction[] {
    try {
      const promptCompanyName =this.extractCompanyNameFromCompanyIntentPrompt(this.userPromptRaw);
      const companyModalAction=actions.find((x): x is ChatGptOpenModalAction =>
        x.type==='open_modal' && x.modal==='company' && !!x.payload?.companyName
      );

      const userModalAction=actions.find((x): x is ChatGptOpenModalAction =>
        x.type==='open_modal' && (x.modal==='user_portal' || x.modal==='user_sim') && !!x.payload?.userName
      );

      const userName             =userModalAction?.payload?.userName;
      const companyNavigateAction=actions.find((x): x is ChatGptNavigateAction =>
        x.type==='navigate' && (x.destination==='company' || x.destination==='companies') && !!x.payload?.companyName
      );
      const companyName=companyModalAction?.payload?.companyName ??
                        companyNavigateAction?.payload?.companyName ??
                        promptCompanyName;

      if (!companyName)
        return actions;

      let enriched=actions.map(action => {
        if (action.type==='navigate' &&
            (action.destination==='company' || action.destination==='companies') &&
            !action.payload?.companyName) {
          return {
            ...action,
            payload: {
              ...(action.payload ?? {}),
              companyName: companyName
            }
          };
        }
        return action;
      });

      if (userName) {
        enriched=enriched.map(action => {
          if (action.type==='navigate' &&
              (action.destination==='portalusers' || action.destination==='simusers') && !action.payload?.userName) {
            return {
              ...action,
              payload: {
                ...(action.payload ?? {}),
                userName: userName
              }
            };
          }
          return action;
        });
      }

      if (!enriched.some(x => x.type==='navigate' && (x.destination==='company' || x.destination==='companies'))) {
        enriched.push({
          type       : 'navigate',
          destination: 'companies',
          payload    : { companyName },
          label      : 'Open companies grid'
        });
      }

      if (!enriched.some(x => x.type==='open_modal' && x.modal==='company')) {
        enriched.push({
          type   : 'open_modal',
          modal  : 'company',
          payload: { companyName },
          label  : 'Open company form'
        });
      }

      return enriched;
    }
    catch {
      return actions;
    }
  }

  private extractCompanyNameFromCompanyIntentPrompt(prompt: string): string | undefined {
    try {
      const raw=(prompt ?? '').trim();

      if (!raw)
        return undefined;
  
      if (/^(open|find|show|view|edit)\s+(portal\s+user|sim\s+user|esim\s+user|user)\s+/i.test(raw))
        return undefined;
      
      if (/^(open|find|show|view|edit)\s+(sim|esim|device|iccid|ticket|tickets)\s+/i.test(raw))
        return undefined;
  
      const match                       =raw.match(/^(open|find|show|view|edit)\s+company\s+(.+)$/i);
      const fallbackMatch               =raw.match(/^company\s+(.+)$/i);
      const shortIntentMatch            =raw.match(/^(open|show|view|edit)\s+(.+)$/i);
      const shortValue                  =shortIntentMatch?.[2]?.trim();
      const shortValueIsKnownDestination=this.isLikelyNonCompanyDestination(shortValue ?? "");
      const value=match?.[2] ??
                  fallbackMatch?.[1] ??
                  (!shortValueIsKnownDestination ? shortValue : undefined);
  
      if (!value)
        return undefined;
  
      let name=value.trim();
      name    =name.replace(/^for\s+/i, '').trim();
      name    =name.replace(/^["']+|["']+$/g, '').trim();

      return name.length > 0 ? name : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private forcedUserIntentFromGenericFind(findTerm: string | undefined): ChatGptForcedUserIntent | undefined {
    try {
      const term=(findTerm ?? '').trim();

      if (!term)
        return undefined;
  
      const userMatch=term.match(/^(portal\s+user|sim\s+user|esim\s+user|user)\s+(.+)$/i);

      if (!userMatch?.[2])
        return undefined;
  
      //CRN_20260225 - Generic 'user' keyword searches both portal and SIM users
      const userType=/^(sim\s+user|esim\s+user)$/i.test(userMatch[1]) ? 'sim' : /^portal\s+user$/i.test(userMatch[1]) ? 'portal' : 'any';
      const userName=this.cleanPromptEntity(userMatch[2]);

      return userName ? { userName, userType } : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private buildCompanyIntentActions(companyName: string, companyId?: number): ChatGptAction[] {
    try {
      return this.sureSimSearchService.buildCompanyIntentActions(companyName, companyId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private extractUserIntentFromPrompt(prompt: string): ChatGptForcedUserIntent | undefined {
    try {
      const raw=(prompt ?? '').trim();
      
      if (!raw)
        return undefined;
  
      const matchPortal=raw.match(/^(open|find|show|view|edit)\s+(portal\s+user)\s+(.+)$/i);

      if (matchPortal?.[3]) {
        const userName=this.cleanPromptEntity(matchPortal[3]);
        return userName ? { userName, userType: 'portal' } : undefined;
      }

      //CRN_20260225 - 'user' keyword==both Portal & SIM users
      const matchAnyUser=raw.match(/^(open|find|show|view|edit)\s+(user)\s+(.+)$/i);

      if (matchAnyUser?.[3]) {
        const userName=this.cleanPromptEntity(matchAnyUser[3]);
        return userName ? { userName, userType: 'any' } : undefined;
      }

      const matchSim=raw.match(/^(open|find|show|view|edit)\s+(sim\s+user|esim\s+user)\s+(.+)$/i);

      if (matchSim?.[3]) {
        const userName=this.cleanPromptEntity(matchSim[3]);
        return userName ? { userName, userType: 'sim' } : undefined;
      }
  
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private buildUserIntentActions(userName: string, userType: 'portal' | 'sim', matchedUser?: UserDTO): ChatGptAction[] {
    try {
      return this.sureSimSearchService.buildUserIntentActions(userName, userType, matchedUser);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private cleanPromptEntity(value: string): string | undefined {
    try {
      let entity=(value ?? '').trim();
      entity    =entity.replace(/^for\s+/i, '').trim();
      entity    =entity.replace(/^["']+|["']+$/g, '').trim();

      return entity.length > 0 ? entity : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private getUserSearchCompanyId(): number {
    try {
      return this.sureSimSearchService.resolveSearchCompanyId(this.curUser, this.latestTopBarCompanyId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 0;
    }
  }
  
  private appendRefineSearchNote(truncated: boolean): void {
    try {
      if (!truncated)
        return;

      const current=(this.chatGptForm.controls["response"].value ?? '').toString();

      this.chatGptForm.controls["response"].setValue(`${current}\nSome results were limited. Refine your search to see more.`.trim());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private userSearchKinds(includePortal: boolean, includeSim: boolean): AssistantSearchKind[] {
    try {
      const kinds: AssistantSearchKind[]=[];

      if (includePortal)
        kinds.push('PortalUsers');

      if (includeSim)
        kinds.push('SimUsers');

      return kinds;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return ['PortalUsers', 'SimUsers'];
    }
  }

  private uniqueUsersById(users: UserDTO[]): UserDTO[] {
    try {
      return this.sureSimSearchService.uniqueUsersById(users);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private buildUserActionsForMatchedUser(user: UserDTO): ChatGptAction[] {
    try {
      return this.sureSimSearchService.buildUserActionsForMatchedUser(user);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private actionDisplayOrder(action: ChatGptAction): number {
    try {
      return this.sureSimSearchService.actionDisplayOrder(action);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return 0;
    }
  }

  private limitActionsWithKindCoverage(actions: ChatGptAction[], maxCount: number): ChatGptAction[] {
    try {
      if (maxCount <= 0)
        return [];
      
      if ((actions ?? []).length <= maxCount)
        return actions ?? [];
      
      const result: ChatGptAction[]=[];

      const seen     =new Set<string>();
      const addAction=(action: ChatGptAction | undefined) => {
        if (!action || result.length >= maxCount)
          return;
        
        const key=this.actionItemKey(action);

        if (seen.has(key))
          return;
        
        seen.add(key);
        result.push(action);
      };

      const addActionsForSameCard=(seedAction: ChatGptAction | undefined) => {
        if (!seedAction || result.length >= maxCount)
          return;
        
        const cardKey=this.actionCardKey(seedAction);
        actions
          .filter(action => this.actionCardKey(action)===cardKey)
          .forEach(action => addAction(action));
      };
  
      (['company', 'user', 'sim', 'ticket'] as ChatGptIntentChip[]).forEach(kind => {
        const firstKindAction=actions.find(action => this.actionCardKind(action)===kind);
        addActionsForSameCard(firstKindAction);
      });
  
      actions.forEach(action => addAction(action));
      return result.slice(0, maxCount);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private isLikelyNonCompanyDestination(value: string): boolean {
    try {
      const normalized=(value ?? '').trim().toLowerCase();

      if (!normalized)
        return true;
  
      const knownDestinations=[
        'availablesim',
        'availablesims',
        'companies',
        'company',
        'dash',
        'dashboard',
        'download',
        'esim user',
        'esim',
        'liveview',
        'managesim',
        'managesims',
        'portal user',
        'portaluser',
        'portalusers',
        'provision',
        'report',
        'reporting',
        'reports',
        'sim user',
        'sim',
        'simuser',
        'simusers',
        'supplier',
        'suppliers',
        'ticket',
        'tickets',
        'timeline',
        'upload',
        'user',
      ];
  
      return knownDestinations.includes(normalized);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private extractHeuristicNumber(text: string, key: string): number | undefined {
    try {
      const match=text.match(new RegExp(`"${key}"\\s*:\\s*(-?\\d+)`, 'i'));

      if (!match?.[1])
        return undefined;
      
      const value=Number(match[1]);

      return Number.isFinite(value) ? value : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private extractHeuristicString(text: string, key: string): string | undefined {
    try {
      const match=text.match(new RegExp(`"${key}"\\s*:\\s*"([^"]*)"`, 'i'));
      const value=(match?.[1] ?? '').trim();

      return value.length > 0 ? value : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private isSupportedModalAction(modal: string): modal is ChatGptModalTarget {
    return [
      'company',
      'download',
      'manage_sim',
      'provision',
      'ticket',
      'timeline',
      'upload',
      'user_portal',
      'user_sim',
    ].includes(modal);
  }

  private extractSimIntentFromPrompt(prompt: string): string | undefined {
    try {
      const raw  =(prompt ?? '').trim();
      const match=raw.match(/^(open|find|show|view|edit)\s+(sim|esim|device|iccid)\s+(.+)$/i);

      if (!match?.[3])
        return undefined;
      
      return this.cleanPromptEntity(match[3]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private extractTicketIntentFromPrompt(prompt: string): string | undefined {
    try {
      const raw  =(prompt ?? '').trim();
      const match=raw.match(/^(open|find|show|view)\s+ticket\s+(.+)$/i);

      if (!match?.[2])
        return undefined;
      
      return this.cleanPromptEntity(match[2]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private extractRaiseTicketTargetFromPrompt(prompt: string): string | undefined {
    try {
      const raw  =(prompt ?? '').trim();
      const match=raw.match(/^raise\s+ticket\s+for\s+(.+)$/i);

      if (!match?.[1])
        return undefined;

      return this.cleanPromptEntity(match[1]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private extractNavigationIntentFromPrompt(prompt: string): string | undefined {
    try {
      const raw  =(prompt ?? '').trim();
      const match=raw.match(/^(?:open|show|view|go\s+to|goto|navigate\s+to|take\s+me\s+to)\s+(.+)$/i);

      if (!match?.[1])
        return undefined;

      const destination=this.chatGptService.normalizeMatchText(match[1])
                        .replace(/\s+(page|screen|grid|tab)$/i, '')
                        .replace(/\s+/g, '');

      return ChatGptModalFormComponent.routeAliasMap[destination] ? destination : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private normaliseSearchVerb(prompt: string): string {
    try {
      return (prompt ?? '').replace(/^\s*(?:search\s+for|search|look\s+for|find\s+for)\s+(?=(?:company|portal\s+user|sim\s+user|esim\s+user|user|sim|esim|device|iccid|ticket)\s+)/i, 'find ');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return prompt;
    }
  }

  private extractGlobalFindTerm(prompt: string): string | undefined {
    try {
      const raw  =(prompt ?? '').trim();
      const match=raw.match(/^(?:find|search|look\s+for)\s+(.+)$/i);

      if (!match?.[1])
        return undefined;
  
      const findTarget=(match[1] ?? '').trim();

      if (!findTarget)
        return undefined;
  
      if (/^(company|portal\s+user|sim\s+user|esim\s+user|user|sim|esim|device|iccid|ticket)\s+/i.test(findTarget))
        return undefined;
  
      return this.cleanPromptEntity(findTarget);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private buildSimIntentActions(iccid: string, status?: string, relatedUser?: UserDTO): ChatGptAction[] {
    try {
      return this.sureSimSearchService.buildSimIntentActions(iccid, status, relatedUser);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private buildTicketIntentActions(ticketId    : number,
                                   ticket?     : TicketDTO,
                                   labelSuffix?: string,
                                   status?     : string,
                                   knownTicket?: Ticket): ChatGptAction[] {
    try {
      return this.sureSimSearchService.buildTicketIntentActions(ticketId, ticket, labelSuffix, status, knownTicket);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private buildCompanyDisambiguationActions(companies: CompanyDTO[]): ChatGptAction[] {
    try {
	
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
    return companies.slice(0, 5).flatMap(c => this.buildCompanyIntentActions(c.companyName, Number(c.id)));
  }

  private buildUserDisambiguationActions(users: UserDTO[], userType: 'portal' | 'sim'): ChatGptAction[] {
    try {
      return users.slice(0, 5).flatMap(u => this.buildUserIntentActions(u.fullname || u.username || u.email, userType, u));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private buildSimDisambiguationActions(matches: IdAndDescriptionDTO[]): ChatGptAction[] {
    try {
      return matches.slice(0, 5).flatMap(m => this.buildSimIntentActions((m.description ?? '').toString()));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private buildTicketDisambiguationActions(matches: Ticket[]): ChatGptAction[] {
    try {
      return matches.slice(0, 5).flatMap(t => this.buildTicketIntentActions(Number(t.id), this.ticketDtoFromTicket(t), this.ticketMatchLabel(t), t.status, t));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private ticketDtoFromTicket(ticket: Ticket): TicketDTO {
    try {
      return this.sureSimSearchService.ticketDtoFromTicket(ticket);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return <TicketDTO>{};
    }
  }

  private ticketMatchLabel(ticket: Ticket): string {
    try {
      return this.sureSimSearchService.ticketMatchLabel(ticket);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private uniqueActions(actions: ChatGptAction[]): ChatGptAction[] {
    try {
      return this.sureSimSearchService.uniqueActions(actions);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private asTicketDto(value: unknown): TicketDTO {
    return (value as TicketDTO) ?? {};
  }

  private auditAssistantDecision(eventType: string) {
    try {
      this.chatGptService.appendAudit(eventType, this.curUser?.userId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Menus

  //#region Response Menu

  public openPopupMenuResponse(event: MouseEvent) {
    try {
      this.popupMenuResponse.show(event.clientX, event.clientY);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onMenuItemSelected_Response(label: string) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public popupClearResponse() {
    try {
      this.chatGptForm.controls["response"].setValue(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public popupSaveResponse() {
    try {
      this.popupSaveToFile("response", "Response");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Save History or Response

  public popupSaveToFile(controlName: string, partOfFilename: string) {
    try {
      const controlValue=this.chatGptForm.get(controlName)?.value ?? "";
      const blob        =new Blob([controlValue], { type: "text/plain;charset=utf-8" });
      const now         =new Date();
      const yyyy        =now.getFullYear();
      const MM          =String(now.getMonth  () + 1).padStart(2, "0");
      const dd          =String(now.getDate   ()    ).padStart(2, "0");
      const hh          =String(now.getHours  ()    ).padStart(2, "0");
      const mm          =String(now.getMinutes()    ).padStart(2, "0");
      const ss          =String(now.getSeconds()    ).padStart(2, "0");
      const timestamp   =`${yyyy}${MM}${dd} ${hh}${mm}${ss}`;
      const filename    =`SureSIM Assistant ${partOfFilename} ${timestamp}.txt`;
      const url         =window.URL.createObjectURL(blob);
      const a           =document.createElement("a");
      a.href            =url;
      a.download        =filename;
      a.click();
      window.URL.revokeObjectURL(url);

      this.completedModalForm.openForm("Complete", "File has been downloaded", "https://cdn.lordicon.com/tsrgicte.json");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#endregion
}
